/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

//Product page Tabs Lavaggio + guida taglie
(function () {
  var navs = document.querySelectorAll(".tabs .tabs__nav");
  if (!navs.length) return;

  navs.forEach(function ($nav) {
    var tabs = Array.prototype.slice.call($nav.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;

    function getPanel(tab) {
      var link = tab.getAttribute("data-link");
      return document.getElementById(link);
    }

    function activateTab(tab, focusTab) {
      tabs.forEach(function (t) {
        var isCurrent = t === tab;
        var panel = getPanel(t);

        t.setAttribute("aria-selected", isCurrent ? "true" : "false");
        t.setAttribute("tabindex", isCurrent ? "0" : "-1");
        t.classList.toggle("current", isCurrent);

        if (panel) {
          panel.classList.toggle("current", isCurrent);
          panel.hidden = !isCurrent; // oppure panel.style.display = isCurrent ? "" : "none";
        }
      });

      if (focusTab) {
        tab.focus();
      }
    }

    // --- Click ---
    tabs.forEach(function (tab) {
      tab.addEventListener("click", function (e) {
        e.preventDefault();
        activateTab(tab, false);
      });
    });

    // --- Navigazione da tastiera (roving tabindex, attivazione automatica) ---
    $nav.addEventListener("keydown", function (e) {
      var currentIndex = tabs.indexOf(document.activeElement);
      if (currentIndex === -1) return;

      var newIndex = null;

      switch (e.key) {
        case "ArrowRight":
          newIndex = (currentIndex + 1) % tabs.length;
          break;
        case "ArrowLeft":
          newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
          break;
        case "Home":
          newIndex = 0;
          break;
        case "End":
          newIndex = tabs.length - 1;
          break;
        default:
          return; // non gestiamo altri tasti, niente preventDefault
      }

      e.preventDefault();
      activateTab(tabs[newIndex], true);
    });

    // --- Stato iniziale ---
    var initialTab = $nav.querySelector('[role="tab"].current') || tabs[0];
    if (initialTab) activateTab(initialTab, false);
  });
})();

$(".SidebarMenu__Nav .TabList button").on("click", function (e) {
  e.preventDefault();

  var link = $(this).attr("aria-controls");
  var tabPanelToShow = $("#".concat(link));
  // var $linkParent = $(this).parent();
  // var $tab = $(link);
  var activeClass = "is-active";

  $(this)
    .addClass(activeClass)
    .siblings()
    .removeClass(activeClass);

  tabPanelToShow
    .attr('aria-hidden', 'false')
    .siblings()
    .attr('aria-hidden', 'true')

  // //prevent from scolling to anchor tag position
  return false;
});

$('.tabs .tabs__nav ul >li').on('mouseover', 'button', function () {
  $(this).parent().siblings().removeClass("current");
}).on('mouseleave', function () {
  $(this).addClass("current");
});

/* Arricchimento taglie select/popover Ragno con mapping statico da tag prodotto */
(function () {

  /*
   * auto = IT su sito IT, EU su sito non IT
   * it   = forza IT
   * eu   = forza EU
   * both = mostra IT/EU quando disponibili
   */
  var DISPLAY_MODE = 'auto';

  var SIZE_MAPPINGS = {
    donna_abbigliamento: {
      ragno: {
        '0': { it: '38', eu: '34' },
        '1': { it: '40', eu: '36' },
        '2': { it: '42', eu: '38' },
        '3': { it: '44', eu: '40' },
        '4': { it: '46', eu: '42' },
        '5': { it: '48', eu: '44' },
        '6': { it: '50', eu: '46' },
        '7': { it: '52', eu: '48' },
        '8': { it: '54', eu: '50' },
        '9': { it: '56', eu: '52' }
      },
      it: {
        '38': { it: '38', eu: '34' },
        '40': { it: '40', eu: '36' },
        '42': { it: '42', eu: '38' },
        '44': { it: '44', eu: '40' },
        '46': { it: '46', eu: '42' },
        '48': { it: '48', eu: '44' },
        '50': { it: '50', eu: '46' },
        '52': { it: '52', eu: '48' },
        '54': { it: '54', eu: '50' },
        '56': { it: '56', eu: '52' }
      }
    },

    donna_intimo: {
      ragno: {
        '1': { label: 'XXS' },
        '2': { label: 'XS' },
        '3': { label: 'S' },
        '4': { label: 'M' },
        '5': { label: 'L' },
        '6': { label: 'XL' },
        '7': { label: 'XXL' },
        '8': { label: '3XL' }
      }
    },

    uomo_abbigliamento: {
      ragno: {
        '38': { label: 'XS' },
        '39': { label: 'S' },
        '40': { label: 'M' },
        '41': { label: 'L' },
        '42': { label: 'XL' },
        '43': { label: 'XXL' },
        '44': { label: '3XL' }
      },
      it: {
        '46': { label: 'S' },
        '48': { label: 'M' },
        '50': { label: 'L' },
        '52': { label: 'XL' },
        '54': { label: 'XXL' },
        '56': { label: '3XL' },
        '58': { label: '4XL' },
        '60': { label: '5XL' }
      }
    },

    uomo_intimo: {
      ragno: {
        '2': { label: 'XS' },
        '3': { label: 'S' },
        '4': { label: 'M' },
        '5': { label: 'L' },
        '6': { label: 'XL' },
        '7': { label: 'XXL' },
        '8': { label: '3XL' }
      }
    }
  };

  var NO_MAPPING_BUCKET = 'notte';

  function isItalianLocale() {
    var lang = (document.documentElement.lang || '').toLowerCase();
    var path = window.location.pathname.toLowerCase();

    return (
      lang.indexOf('it') === 0 ||
      lang.indexOf('it-') === 0 ||
      path.indexOf('/it') === 0 ||
      document.documentElement.getAttribute('data-country') === 'IT'
    );
  }

  function getDisplayMode() {
    if (DISPLAY_MODE === 'it' || DISPLAY_MODE === 'eu' || DISPLAY_MODE === 'both') {
      return DISPLAY_MODE;
    }

    return isItalianLocale() ? 'it' : 'eu';
  }

  function getSoldOutLabel() {
    var holder = document.querySelector('[data-ragno-sold-out-label]');
    var label = holder ? holder.getAttribute('data-ragno-sold-out-label') : '';

    if (label) return label;

    return isItalianLocale() ? 'Esaurito' : 'Sold out';
  }

  function escapeRegExp(value) {
    return String(value || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function normalizeText(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '');
  }

  function stripSuffix(value) {
    var soldOutLabel = getSoldOutLabel();

    return String(value || '')
      .replace(/\s*-\s*(Sold out|Esaurito|Non disponibile)$/i, '')
      .replace(new RegExp('\\s*-\\s*' + escapeRegExp(soldOutLabel) + '$', 'i'), '')
      .replace(/\s+\((IT|EU)\s+[^)]+\)$/i, '')
      .replace(/\s+\((IT\s+[^/)]*\s*\/\s*EU\s+[^)]*)\)$/i, '')
      .replace(/\s+\((XXS|XS|S|M|L|XL|XXL|XXXL|3XL|4XL|5XL|SXL)\)$/i, '')
      .trim();
  }

  function uniquePush(arr, value) {
    if (!value) return;
    if (arr.indexOf(value) === -1) arr.push(value);
  }

  function collectTagsFromObject(obj, tags) {
    if (!obj || typeof obj !== 'object') return;

    if (Array.isArray(obj)) {
      obj.forEach(function (item) {
        collectTagsFromObject(item, tags);
      });
      return;
    }

    Object.keys(obj).forEach(function (key) {
      var value = obj[key];

      if (key === 'tags') {
        if (Array.isArray(value)) {
          value.forEach(function (tag) {
            uniquePush(tags, String(tag));
          });
        } else if (typeof value === 'string') {
          value.split(',').forEach(function (tag) {
            uniquePush(tags, tag.trim());
          });
        }
      }

      if (value && typeof value === 'object') {
        collectTagsFromObject(value, tags);
      }
    });
  }

  function getProductTags() {
    var tags = [];

    document
      .querySelectorAll('script[type="application/json"], script[type="application/ld+json"]')
      .forEach(function (script) {
        var text = script.textContent;

        if (!text || text.indexOf('tags') === -1) return;

        try {
          var json = JSON.parse(text);
          collectTagsFromObject(json, tags);
        } catch (e) {}
      });

    document.querySelectorAll('[data-product-tags], [data-tags]').forEach(function (el) {
      var raw = el.getAttribute('data-product-tags') || el.getAttribute('data-tags');

      if (!raw) return;

      raw.split(',').forEach(function (tag) {
        uniquePush(tags, tag.trim());
      });
    });

    return tags;
  }

  function hasNormalizedTag(tags, expected) {
    var normalizedExpected = normalizeText(expected);

    return tags.some(function (tag) {
      var normalizedTag = normalizeText(tag);

      return (
        normalizedTag === normalizedExpected ||
        normalizedTag.indexOf(normalizedExpected) !== -1
      );
    });
  }
  function hasExactNormalizedTag(tags, expected) {
    var normalizedExpected = normalizeText(expected);

    return tags.some(function (tag) {
      return normalizeText(tag) === normalizedExpected;
    });
  }

  function getProductContextText() {
    var parts = [];

    if (document.title) {
      parts.push(document.title);
    }

    var h1 = document.querySelector('h1');
    if (h1) {
      parts.push(h1.textContent);
    }

    document
      .querySelectorAll('.Breadcrumb, .breadcrumb, [class*="Breadcrumb"], [class*="breadcrumb"]')
      .forEach(function (el) {
        parts.push(el.textContent);
      });

    parts.push(window.location.pathname);

    return normalizeText(parts.join(' '));
  }

  function detectBucketFromTags(tags) {
    var isDonna =
      hasNormalizedTag(tags, 'settore_donna') ||
      hasNormalizedTag(tags, 'donna');

    var isUomo =
      hasNormalizedTag(tags, 'settore_uomo') ||
      hasNormalizedTag(tags, 'uomo');

    var isAbbigliamento =
      hasNormalizedTag(tags, 'categoria_abbigliamento') ||
      hasNormalizedTag(tags, 'abbigliamento');

    var isIntimo =
      hasNormalizedTag(tags, 'categoria_intimo') ||
      hasNormalizedTag(tags, 'intimo');

    var isNotte =
      hasExactNormalizedTag(tags, 'categoria_notte') ||
      hasExactNormalizedTag(tags, 'class_notte') ||
      hasExactNormalizedTag(tags, 'menu_notte') ||
      hasExactNormalizedTag(tags, 'menu_donna_notte') ||
      hasExactNormalizedTag(tags, 'menu_uomo_notte') ||
      hasExactNormalizedTag(tags, 'notte');

    if (isNotte) return NO_MAPPING_BUCKET;

    if (isDonna && isAbbigliamento) return 'donna_abbigliamento';
    if (isDonna && isIntimo) return 'donna_intimo';
    if (isUomo && isAbbigliamento) return 'uomo_abbigliamento';
    if (isUomo && isIntimo) return 'uomo_intimo';

    return null;
  }

  function detectBucketFallback() {
    var context = getProductContextText();

    var isNotte =
      context.indexOf('categoria_notte') !== -1 ||
      context.indexOf('menu_notte') !== -1 ||
      context.indexOf('menu_donna_notte') !== -1 ||
      context.indexOf('menu_uomo_notte') !== -1 ||
      context.indexOf('pigiama') !== -1 ||
      context.indexOf('pigiami') !== -1 ||
      context.indexOf('vestaglia') !== -1 ||
      context.indexOf('camicia_da_notte') !== -1;

    if (isNotte) return NO_MAPPING_BUCKET;

    var isDonna =
      context.indexOf('donna') !== -1 ||
      context.indexOf('_dq') !== -1 ||
      context.indexOf('_dn') !== -1 ||
      context.indexOf('_dp') !== -1 ||
      context.indexOf('_dt') !== -1;

    var isUomo =
      context.indexOf('uomo') !== -1 ||
      context.indexOf('_u') !== -1;

    var isIntimo =
      context.indexOf('intimo') !== -1 ||
      context.indexOf('slip') !== -1 ||
      context.indexOf('pants') !== -1 ||
      context.indexOf('boxer') !== -1 ||
      context.indexOf('parigamba') !== -1 ||
      context.indexOf('canottiera') !== -1 ||
      context.indexOf('canottiere') !== -1 ||
      context.indexOf('reggiseno') !== -1 ||
      context.indexOf('reggiseni') !== -1 ||
      context.indexOf('calzamaglia') !== -1;

    var isAbbigliamento =
      context.indexOf('abbigliamento') !== -1 ||
      context.indexOf('outerwear') !== -1 ||
      context.indexOf('cappotto') !== -1 ||
      context.indexOf('piumino') !== -1 ||
      context.indexOf('smanicato') !== -1 ||
      context.indexOf('pantalone') !== -1 ||
      context.indexOf('pantaloni') !== -1 ||
      context.indexOf('jeans') !== -1 ||
      context.indexOf('giacca') !== -1 ||
      context.indexOf('blazer') !== -1 ||
      context.indexOf('maglia') !== -1 ||
      context.indexOf('top') !== -1 ||
      context.indexOf('maglieria') !== -1 ||
      context.indexOf('camicia') !== -1;

    if (isDonna && isIntimo) return 'donna_intimo';
    if (isUomo && isIntimo) return 'uomo_intimo';
    if (isDonna && isAbbigliamento) return 'donna_abbigliamento';
    if (isUomo && isAbbigliamento) return 'uomo_abbigliamento';

    return null;
  }

  function getCurrentBucket() {
    var tags = getProductTags();
    var bucket = detectBucketFromTags(tags);

    if (bucket) return bucket;

    return detectBucketFallback();
  }

  function getMappingConfigForCurrentProduct() {
    var bucket = getCurrentBucket();

    if (!bucket || bucket === NO_MAPPING_BUCKET) {
      return null;
    }

    var mapping = SIZE_MAPPINGS[bucket];

    if (!mapping) {
      return null;
    }

    return {
      bucket: bucket,
      mapping: mapping
    };
  }

  function getVariantOptionValue(variant, optionIndexZeroBased) {
    if (!variant) return '';

    if (Array.isArray(variant.options)) {
      return variant.options[optionIndexZeroBased] || '';
    }

    return variant['option' + (optionIndexZeroBased + 1)] || '';
  }

  function getVariantById(variantId) {
    var product = window.theme && window.theme.currentProduct;

    if (!product || !Array.isArray(product.variants) || !variantId) {
      return null;
    }

    return product.variants.find(function (variant) {
      return String(variant.id) === String(variantId);
    }) || null;
  }

  function getCurrentVariant() {
    var product = window.theme && window.theme.currentProduct;

    if (!product || !Array.isArray(product.variants)) {
      return null;
    }

    var eventVariant = window.ragnoCurrentVariant;

    if (eventVariant && eventVariant.id) {
      var fromEvent = getVariantById(eventVariant.id);
      if (fromEvent) return fromEvent;
    }

    var select = document.querySelector('select.js-product-select');

    if (select && select.value) {
      var fromSelect = getVariantById(select.value);
      if (fromSelect) return fromSelect;
    }

    var urlParams = new URLSearchParams(window.location.search);
    var variantId = urlParams.get('variant');

    if (variantId) {
      var fromUrl = getVariantById(variantId);
      if (fromUrl) return fromUrl;
    }

    return product.selected_or_first_available_variant || product.variants[0] || null;
  }

  function getOptionValueFromDom(optionPosition) {
    var positionIndex = parseInt(optionPosition, 10) - 1;

    if (isNaN(positionIndex)) return '';

    var checkedRadio = document.querySelector(
      '.js-radio-option[data-option-position="' + optionPosition + '"]:checked'
    );

    if (checkedRadio) {
      return stripSuffix(checkedRadio.value);
    }

    var popoverButton = document.querySelector(
      '.ProductForm__Item--anchored[data-option-position="' + optionPosition + '"] .ProductForm__SelectedValue'
    );

    if (popoverButton) {
      return stripSuffix(popoverButton.textContent);
    }

    var currentVariant = getCurrentVariant();

    if (currentVariant) {
      return stripSuffix(getVariantOptionValue(currentVariant, positionIndex));
    }

    return '';
  }

  function isOptionValueAvailable(optionPosition, value) {
    var product = window.theme && window.theme.currentProduct;
    var optionIndex = parseInt(optionPosition, 10) - 1;

    if (!product || !Array.isArray(product.variants) || isNaN(optionIndex)) {
      return true;
    }

    var cleanValue = stripSuffix(value);

    return product.variants.some(function (variant) {
      if (!variant.available) return false;

      var variantValue = stripSuffix(getVariantOptionValue(variant, optionIndex));

      if (String(variantValue) !== String(cleanValue)) {
        return false;
      }

      /*
       * Mantengo ferme le altre opzioni correnti.
       * Esempio:
       * - sto valutando la taglia
       * - controllo se quella taglia è disponibile per il colore attuale
       */
      for (var i = 0; i < 3; i++) {
        if (i === optionIndex) continue;

        var currentOptionValue = getOptionValueFromDom(i + 1);
        var candidateOptionValue = stripSuffix(getVariantOptionValue(variant, i));

        if (
          currentOptionValue &&
          candidateOptionValue &&
          String(currentOptionValue) !== String(candidateOptionValue)
        ) {
          return false;
        }
      }

      return true;
    });
  }

  function setOptionLabel(el, label, isSoldOut) {
    var finalLabel = label;

    if (isSoldOut) {
      finalLabel += ' - ' + getSoldOutLabel();
    }

    el.textContent = finalLabel;
    el.classList.toggle('is-unavailable', !!isSoldOut);
    el.setAttribute('data-ragno-sold-out', isSoldOut ? 'true' : 'false');
    el.setAttribute('aria-disabled', isSoldOut ? 'true' : 'false');
  }

  function getOriginalValue(el, options) {
    options = options || {};

    var shouldRefresh =
      options.refresh === true ||
      el.classList.contains('ProductForm__SelectedValue');

    if (!el.dataset.ragnoOriginalSizeValue || shouldRefresh) {
      var value =
        el.getAttribute('data-value') ||
        el.getAttribute('value') ||
        el.textContent;

      el.dataset.ragnoOriginalSizeValue = stripSuffix(value);
    }

    return stripSuffix(el.dataset.ragnoOriginalSizeValue);
  }

  function getCellText(cell) {
    return String(cell ? cell.textContent : '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function extractOnlyItalianMappingFromKsTable(table) {
    if (!table) {
      return null;
    }

    var rows = Array.from(table.querySelectorAll('tr, .ks-table-row'));

    if (!rows.length) {
      return null;
    }

    var headerCells = Array.from(rows[0].querySelectorAll('th, td, .ks-table-cell'));

    var ragnoIndex = -1;
    var itIndex = -1;
    var euIndex = -1;

    headerCells.forEach(function (cell, index) {
      var header = normalizeText(getCellText(cell));

      if (
        header.indexOf('ragno_size') !== -1 ||
        (header.indexOf('ragno') !== -1 && header.indexOf('size') !== -1)
      ) {
        ragnoIndex = index;
      }

      if (
        header.indexOf('taglia_it') !== -1 ||
        header.indexOf('size_it') !== -1 ||
        header.indexOf('italian_size') !== -1 ||
        (header.indexOf('italian') !== -1 && header.indexOf('size') !== -1)
      ) {
        itIndex = index;
      }

      if (
        header.indexOf('taglia_eu') !== -1 ||
        header.indexOf('size_eu') !== -1 ||
        header.indexOf('european_size') !== -1 ||
        (header.indexOf('eu') !== -1 && header.indexOf('size') !== -1)
      ) {
        euIndex = index;
      }
    });

    /*
    * Patch conservativa:
    * uso questa tabella SOLO se ha RAGNO SIZE + TAGLIA (IT)
    * e NON ha una colonna EU.
    */
    if (ragnoIndex === -1 || itIndex === -1 || euIndex !== -1) {
      return null;
    }

    var result = {};

    rows.slice(1).forEach(function (row) {
      var cells = Array.from(row.querySelectorAll('th, td, .ks-table-cell'));

      var ragnoSize = stripSuffix(getCellText(cells[ragnoIndex]));
      var itSize = stripSuffix(getCellText(cells[itIndex]));

      if (!ragnoSize || ragnoSize === '-' || !itSize || itSize === '-') {
        return;
      }

      result[ragnoSize] = {
        it: itSize
      };
    });

    return Object.keys(result).length ? result : null;
  }

  function getKsTableOnlyItalianMapping() {
    var tables = Array.from(document.querySelectorAll('.ks-table'));

    if (!tables.length) {
      return null;
    }

    for (var i = 0; i < tables.length; i++) {
      var mapping = extractOnlyItalianMappingFromKsTable(tables[i]);

      if (mapping) {
        return mapping;
      }
    }

    return null;
  }

  function findMappedDataFromKsTableOnlyItalian(value) {
    var cleanValue = stripSuffix(value);
    var tableMapping = getKsTableOnlyItalianMapping();

    if (!tableMapping || !tableMapping[cleanValue]) {
      return null;
    }

    return {
      source: 'ks-table-only-it',
      data: tableMapping[cleanValue]
    };
  }

  function findMappedData(value, mapping) {
    var cleanValue = stripSuffix(value);

    /*
    * Prima controllo se nella pagina esiste una tabella solo IT.
    * Questo serve per prodotti dove la tabella ha:
    * RAGNO SIZE | TAGLIA (IT)
    *
    * In quel caso anche su /en-en vogliamo mostrare:
    * 1 (IT 40)
    */
    var tableOnlyItMapped = findMappedDataFromKsTableOnlyItalian(cleanValue);

    if (tableOnlyItMapped) {
      return tableOnlyItMapped;
    }

    /*
    * Tutto il comportamento esistente resta identico.
    */
    if (!mapping) return null;

    if (mapping.ragno && mapping.ragno[cleanValue]) {
      return {
        source: 'ragno',
        data: mapping.ragno[cleanValue]
      };
    }

    if (mapping.it && mapping.it[cleanValue]) {
      return {
        source: 'it',
        data: mapping.it[cleanValue]
      };
    }

    return null;
  }

  function formatSizeLabel(baseValue, mapping) {
    var cleanValue = stripSuffix(baseValue);
    var mapped = findMappedData(cleanValue, mapping);

    if (!mapped) {
      return cleanValue;
    }

    var data = mapped.data;

    if (data.label) {
      if (String(data.label).toLowerCase() === String(cleanValue).toLowerCase()) {
        return cleanValue;
      }

      return cleanValue + ' (' + data.label + ')';
    }

    var mode = getDisplayMode();

    function hasValue(value) {
      return value !== undefined && value !== null && String(value) !== '';
    }

    if (mode === 'both') {
      var parts = [];

      if (hasValue(data.it)) {
        parts.push('IT ' + data.it);
      }

      if (hasValue(data.eu)) {
        parts.push('EU ' + data.eu);
      }

      if (parts.length) {
        return cleanValue + ' (' + parts.join(' / ') + ')';
      }

      return cleanValue;
    }

    if (mode === 'it') {
      if (hasValue(data.it)) {
        return cleanValue + ' (IT ' + data.it + ')';
      }

      if (hasValue(data.eu)) {
        return cleanValue + ' (EU ' + data.eu + ')';
      }

      return cleanValue;
    }

    if (mode === 'eu') {
      if (hasValue(data.eu)) {
        return cleanValue + ' (EU ' + data.eu + ')';
      }

      /*
      * Caso tabella solo italiana:
      * anche sul sito inglese mostro la stessa taglia IT,
      * senza rinominarla falsamente EU.
      */
      if (hasValue(data.it)) {
        return cleanValue + ' (IT ' + data.it + ')';
      }

      return cleanValue;
    }

    return cleanValue;
  }

  function getSizePopovers() {
    var result = [];

    document.querySelectorAll('.ProductForm__Option').forEach(function (optionDiv) {
      var label = optionDiv.querySelector('.SizeForm__Label');

      if (!label) return;

      var trigger = optionDiv.querySelector('[aria-controls]');

      if (!trigger) return;

      var id = trigger.getAttribute('aria-controls');
      var popover = document.getElementById(id);

      if (popover) {
        result.push({
          trigger: trigger,
          popover: popover
        });
      }
    });

    return result;
  }

  function getTriggerOptionPosition(trigger) {
    if (!trigger) return '';

    return (
      trigger.getAttribute('data-option-position') ||
      trigger.closest('[data-option-position]')?.getAttribute('data-option-position') ||
      ''
    );
  }

  function resetPopoverLabels() {
    getSizePopovers().forEach(function (pair) {
      pair.popover
        .querySelectorAll('.Popover__Value[data-action="select-value"]')
        .forEach(function (btn) {
          var original = getOriginalValue(btn);
          var optionPosition = btn.getAttribute('data-option-position');
          var isSoldOut = !isOptionValueAvailable(optionPosition, original);

          setOptionLabel(btn, original, isSoldOut);
        });

      var selectedValueSpan = pair.trigger.querySelector('.ProductForm__SelectedValue');

      if (selectedValueSpan) {
        if (selectedValueSpan.getAttribute('data-ragno-placeholder') === 'true') {
          return;
        }
        var currentValue = getOriginalValue(selectedValueSpan, {
          refresh: true
        });

        var triggerOptionPosition = getTriggerOptionPosition(pair.trigger);
        var selectedIsSoldOut = !isOptionValueAvailable(triggerOptionPosition, currentValue);

        setOptionLabel(selectedValueSpan, currentValue, selectedIsSoldOut);
      }
    });
  }

  function enrichPopovers() {
    var config = getMappingConfigForCurrentProduct();
    var tableOnlyItMapping = getKsTableOnlyItalianMapping();

    if (!config && !tableOnlyItMapping) {
      resetPopoverLabels();
      return;
    }

    var mapping = config ? config.mapping : null;

    getSizePopovers().forEach(function (pair) {
      pair.popover
        .querySelectorAll('.Popover__Value[data-action="select-value"]')
        .forEach(function (btn) {
          var original = getOriginalValue(btn);
          var optionPosition = btn.getAttribute('data-option-position');
          var isSoldOut = !isOptionValueAvailable(optionPosition, original);

          setOptionLabel(btn, formatSizeLabel(original, mapping), isSoldOut);
        });

      var selectedValueSpan = pair.trigger.querySelector('.ProductForm__SelectedValue');

      if (selectedValueSpan) {
        if (selectedValueSpan.getAttribute('data-ragno-placeholder') === 'true') {
          return;
        }
        /*
         * Importante:
         * il valore selezionato NON va trattato come statico.
         * Shopify lo cambia quando cambia variante.
         * Quindi qui forziamo il refresh del valore originale.
         */
        var currentValue = getOriginalValue(selectedValueSpan, {
          refresh: true
        });

        var triggerOptionPosition = getTriggerOptionPosition(pair.trigger);
        var selectedIsSoldOut = !isOptionValueAvailable(triggerOptionPosition, currentValue);

        setOptionLabel(
          selectedValueSpan,
          formatSizeLabel(currentValue, mapping),
          selectedIsSoldOut
        );
      }
    });
  }

  function isLikelySizeSelect(select) {
    var normalizedName = normalizeText(select.name || '');
    var normalizedId = normalizeText(select.id || '');
    var normalizedAria = normalizeText(select.getAttribute('aria-label') || '');

    if (
      normalizedName.indexOf('taglia') !== -1 ||
      normalizedName.indexOf('size') !== -1 ||
      normalizedId.indexOf('taglia') !== -1 ||
      normalizedId.indexOf('size') !== -1 ||
      normalizedAria.indexOf('taglia') !== -1 ||
      normalizedAria.indexOf('size') !== -1
    ) {
      return true;
    }

    if (select.classList.contains('js-product-select')) {
      return true;
    }

    return false;
  }

  function enrichNativeSelects() {
    var config = getMappingConfigForCurrentProduct();
    var mapping = config ? config.mapping : null;

    document.querySelectorAll('select').forEach(function (select) {
      if (!isLikelySizeSelect(select)) return;

      Array.from(select.options).forEach(function (option) {
        if (!option.dataset.ragnoOriginalSizeValue) {
          var original =
            option.getAttribute('data-option0') ||
            option.value ||
            option.textContent;

          option.dataset.ragnoOriginalSizeValue = stripSuffix(original);
        }

        var originalValue = stripSuffix(option.dataset.ragnoOriginalSizeValue);

        var label = formatSizeLabel(originalValue, mapping);

        var isSoldOut = option.disabled === true;

        option.textContent = label + (isSoldOut ? ' - ' + getSoldOutLabel() : '');
      });
    });
  }

  function applySizeMapping() {
    enrichPopovers();
    enrichNativeSelects();
  }

  /*
   * Espongo la funzione fuori dalla IIFE.
   * Serve alla logica variante/colore per riapplicare il mapping
   * dopo che il tema Shopify ha aggiornato select o popover.
   */
  window.ragnoApplySizeMapping = applySizeMapping;

  function waitForProductForm(callback) {
    var selector = [
      '.ProductForm__Option',
      '.Popover__Value[data-action="select-value"]',
      'select.js-product-select',
      'select[name*="option"]',
      'select[name*="Option"]'
    ].join(',');

    if (document.querySelector(selector)) {
      callback();
      return;
    }

    var observer = new MutationObserver(function () {
      if (document.querySelector(selector)) {
        observer.disconnect();
        callback();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function debounce(fn, delay) {
    var timer = null;

    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, delay || 50);
    };
  }

  var debouncedApply = debounce(applySizeMapping, 80);

  function applySizeMappingAfterThemeUpdate(event) {
    if (event && event.detail && event.detail.variant) {
      window.ragnoCurrentVariant = event.detail.variant;
    }

    debouncedApply();

    requestAnimationFrame(function () {
      applySizeMapping();
    });

    setTimeout(applySizeMapping, 80);
    setTimeout(applySizeMapping, 200);
  }

  waitForProductForm(function () {
    applySizeMapping();

    document.addEventListener('variant:changed', applySizeMappingAfterThemeUpdate);
    document.addEventListener('change', applySizeMappingAfterThemeUpdate);
      
    document.addEventListener('click', function (e) {
      var valueButton = e.target.closest('.Popover__Value[data-action="select-value"]');

      if (valueButton) {
        var popoverEl = valueButton.closest('[id]');
        var trigger = popoverEl ? document.querySelector('[aria-controls="' + popoverEl.id + '"]') : null;
        var selectedValueSpan = trigger ? trigger.querySelector('.ProductForm__SelectedValue') : null;

        if (selectedValueSpan) {
          var rawValue = valueButton.getAttribute('data-value') || valueButton.textContent;

          selectedValueSpan.textContent = stripSuffix(rawValue);
          selectedValueSpan.setAttribute('data-ragno-placeholder', 'false');

          // forza il refresh del valore "originale" salvato in cache
          delete selectedValueSpan.dataset.ragnoOriginalSizeValue;
        }

        var product = window.theme && window.theme.currentProduct;

        if (product && Array.isArray(product.variants)) {
          var pos1Value = getOptionValueFromDom(1);
          var pos2Value = getOptionValueFromDom(2);
          var pos3Value = getOptionValueFromDom(3);

          var matchedVariant = product.variants.find(function (variant) {
            var v1 = stripSuffix(getVariantOptionValue(variant, 0));
            var v2 = stripSuffix(getVariantOptionValue(variant, 1));
            var v3 = stripSuffix(getVariantOptionValue(variant, 2));

            return (
              (!pos1Value || String(v1) === String(pos1Value)) &&
              (!pos2Value || String(v2) === String(pos2Value)) &&
              (!pos3Value || String(v3) === String(pos3Value))
            );
          });

          if (matchedVariant) {
            document.dispatchEvent(new CustomEvent('variant:changed', {
              detail: { variant: matchedVariant }
            }));
          }
        }
      }
      if (
        valueButton ||
        e.target.closest('.ProductForm__Option') ||
        e.target.closest('.ProductForm__Item--anchored')
      ) {
        applySizeMappingAfterThemeUpdate();
      }
    });

    var observer = new MutationObserver(debouncedApply);

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });

})();

/* Select popover dropdown PDP */
// Posiziona il popover delle varianti sotto il bottone — SOLO da desktop in su
(function () {
  var DESKTOP_BREAKPOINT = '(min-width: 1024px)'; // verifica che combaci col CSS sopra

  function isDesktop() {
    return window.matchMedia(DESKTOP_BREAKPOINT).matches;
  }

  function positionPopover(trigger, popover) {
    var rect = trigger.getBoundingClientRect();
    popover.style.top = (rect.bottom + 8) + 'px';
    popover.style.left = rect.left + 'px';
    popover.style.width = rect.width + 'px';
  }

  function getPopoverFor(trigger) {
    var id = trigger.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  }

  document.addEventListener('click', function (e) {
    if (!isDesktop()) return; // su mobile non facciamo nulla, resta il comportamento originale

    var trigger = e.target.closest('.ProductForm__Item--anchored');
    if (!trigger) return;

    var popover = getPopoverFor(trigger);
    if (!popover || !popover.classList.contains('Popover--anchored')) return;

    document.documentElement.classList.remove('no-scroll');

    requestAnimationFrame(function () {
      if (popover.getAttribute('aria-hidden') === 'false') {
        popover.classList.add('is-anchored-active');
        positionPopover(trigger, popover);
        document.documentElement.classList.remove('no-scroll');
      } else {
        popover.classList.remove('is-anchored-active');
      }
    });
  });

  var scrollStartY = null;
  var SCROLL_CLOSE_THRESHOLD = 4;

  function closeAnchoredPopover(popover) {
    var trigger = document.querySelector('[aria-controls="' + popover.id + '"]');
    if (trigger) trigger.click(); // riusa il toggle originale del tema (close pulito)
  }

  function handleScrollClose() {
    if (!isDesktop()) return;

    var activePopover = document.querySelector('.Popover--anchored.is-anchored-active');
    if (!activePopover) {
      scrollStartY = null;
      return;
    }

    if (scrollStartY === null) {
      scrollStartY = window.scrollY;
      return;
    }

    if (Math.abs(window.scrollY - scrollStartY) > SCROLL_CLOSE_THRESHOLD) {
      closeAnchoredPopover(activePopover);
      scrollStartY = null;
    }
  }

  window.addEventListener('scroll', handleScrollClose, true);

  // se l'utente ridimensiona da desktop a mobile con popover aperto, togli la classe
  window.addEventListener('resize', function () {
    if (!isDesktop()) {
      document.querySelectorAll('.Popover--anchored.is-anchored-active').forEach(function (popover) {
        popover.classList.remove('is-anchored-active');
        popover.style.top = '';
        popover.style.left = '';
      });
    }
  });
})();

// Logica pagina prodotto - size + color swatch

var disableOptions = (optionList, selector) => {
  if (optionList.length > 0) {
    optionList.forEach((size) => {
      var radioOption = $(selector).find(`[value="${size.toString().toUpperCase()}"]`);

      if (selector.indexOf("Size") == -1) {
        radioOption = $(selector).find(`[data-color="${size}"]`);
      }

      var parentContainer = $(radioOption).parent();
      var label = parentContainer.find('label');
      var soldOutIcon = $(parentContainer).find(".icon-ui-soldout");

      $(soldOutIcon).css("display", "block");

      $(label)
        .addClass('Option__Unavailable')
        .attr("aria-disabled", "true");

      $(radioOption)
        .attr("aria-disabled", "true");
    });
  }
};

const handleize = (str) => {
  var regexJapanText = RegExp(/[\u3000-\u303f\u3040-\u309f\u30a0-\u30ff\uff00-\uff9f\u4e00-\u9faf\u3400-\u4dbf]/);

  if (regexJapanText.test(str)) {
    return str;
  }

  return str
    .toLowerCase()
    .replace(/\'+/g, '')
    .replace(/[^\w\u00C0-\u024f]+/g, '-')
    .replace(/^-+|-+$/g, '');
};

function normalizeVariantValue(value) {
  return String(value || '').trim().toLowerCase();
}

function parseUnavailableSizes(value) {
  return String(value || '')
    .split(',')
    .map(function (item) {
      return normalizeVariantValue(item);
    })
    .filter(Boolean);
}
function parseVariantSizes(value) {
  const sizes = [];

  String(value || '')
    .split(',')
    .map(function (item) {
      const parts = item.split(':');
      return normalizeVariantValue(parts[0]);
    })
    .filter(Boolean)
    .forEach(function (size) {
      if (sizes.indexOf(size) === -1) {
        sizes.push(size);
      }
    });

  return sizes;
}

function shouldStartWithoutSelectedVariant() {
  return (
    window.theme &&
    window.theme.isFirstVariantSelected === false &&
    !window.location.href.includes('?variant')
  );
}

function clearInitialSizeSwatchSelection() {
  if (!shouldStartWithoutSelectedVariant()) {
    return;
  }

  $('.SizeSwatchList .js-radio-option')
    .prop('checked', false)
    .removeAttr('checked');

  window.ragnoSelectedSizeFromVariant = '';

  try {
    sessionStorage.removeItem('ragnoSelectedSize');
  } catch (error) {}
}

function resetSizeSwatchesAvailability(selector) {
  const $container = $(selector || '.SizeSwatchList');

  $container.find('.js-radio-option').each(function () {
    const $radio = $(this);
    const $item = $radio.closest('.HorizontalList__Item');
    const $label = $item.find('label.SizeSwatch');
    const $icon = $item.find('.icon-ui-soldout');

    $item.removeClass('is-size-unavailable');

    $radio
      .removeAttr('aria-disabled');

    $label
      .removeClass('Option__Unavailable')
      .removeAttr('aria-disabled');

    $icon
      .removeAttr('style')
      .css('display', 'none');
  });
}

function refreshSizeSwatchesAvailability(optionList, selector) {
  const $container = $(selector || '.SizeSwatchList');

  resetSizeSwatchesAvailability($container);

  const unavailableSizes = parseUnavailableSizes(
    Array.isArray(optionList) ? optionList.join(',') : optionList
  );

  unavailableSizes.forEach(function (size) {
    $container.find('.js-radio-option').each(function () {
      const $radio = $(this);
      const radioValue = normalizeVariantValue($radio.val());

      if (radioValue !== size) {
        return;
      }

      const $item = $radio.closest('.HorizontalList__Item');
      const $label = $item.find('label.SizeSwatch');
      const $icon = $item.find('.icon-ui-soldout');

      $item.addClass('is-size-unavailable');

      $radio.attr('aria-disabled', 'true');

      $label
        .addClass('Option__Unavailable')
        .attr('aria-disabled', 'true');

      $icon.css('display', 'block');
    });
  });
}

function hideColorSwatchesWithoutAvailableSizes() {
  $('.product__color-swatches [data-action="change-color-variant"]').each(function () {
    const $swatch = $(this);
    const $item = $swatch.closest('.HorizontalList__Item');

    const allSizes = parseVariantSizes($swatch.attr('data-variants-ids'));
    const unavailableSizes = parseUnavailableSizes($swatch.attr('data-variants-no-inventory'));

    const hasAvailableSize = allSizes.some(function (size) {
      return unavailableSizes.indexOf(size) === -1;
    });

    $item.toggleClass('is-color-fully-unavailable', !hasAvailableSize);
  });
}

function getVariantByIdFromCurrentProduct(variantId) {
  const product = window.theme && window.theme.currentProduct;

  if (!product || !Array.isArray(product.variants) || !variantId) {
    return null;
  }

  return product.variants.find(function (variant) {
    return String(variant.id) === String(variantId);
  }) || null;
}

function getVariantSizeValue(variant) {
  if (!variant) {
    return '';
  }

  if (variant.option1) {
    return normalizeVariantValue(variant.option1);
  }

  if (Array.isArray(variant.options) && variant.options[0]) {
    return normalizeVariantValue(variant.options[0]);
  }

  return '';
}

function getSizeFromUrlVariant() {
  const urlParams = new URLSearchParams(window.location.search);
  const variantId = urlParams.get('variant');

  if (!variantId) {
    return '';
  }

  const variant = getVariantByIdFromCurrentProduct(variantId);

  if (!variant) {
    return '';
  }

  return getVariantSizeValue(variant);
}

function getSelectedSizeValue() {
  const checkedRadioValue = $('.SizeSwatchList .js-radio-option:checked').val();

  if (checkedRadioValue) {
    return normalizeVariantValue(checkedRadioValue);
  }

  if (shouldStartWithoutSelectedVariant()) {
    return '';
  }

  if (window.ragnoSelectedSizeFromVariant) {
    return normalizeVariantValue(window.ragnoSelectedSizeFromVariant);
  }

  const sizeFromUrl = getSizeFromUrlVariant();

  if (sizeFromUrl) {
    return sizeFromUrl;
  }

  try {
    const storedSize = sessionStorage.getItem('ragnoSelectedSize');

    if (storedSize && window.location.href.includes('?variant')) {
      return normalizeVariantValue(storedSize);
    }
  } catch (error) {}

  const selectedLabel = $('.ProductForm__SelectedValue[data-ragno-original-size-value]');

  if (selectedLabel.length) {
    const labelValue = selectedLabel.attr('data-ragno-original-size-value');

    if (labelValue) {
      return normalizeVariantValue(labelValue);
    }
  }

  const selectedOption = $('#product-select option:selected');

  if (selectedOption.length && window.location.href.includes('?variant')) {
    return normalizeVariantValue(
      selectedOption.attr('data-ragno-original-size-value') ||
      selectedOption.attr('data-option0') ||
      selectedOption.text()
    );
  }

  return '';
}

function refreshColorSwatchesAvailability() {
  const selectedSize = getSelectedSizeValue();

  $('[data-action="change-color-variant"]').each(function () {
    const $swatch = $(this);
    const $item = $swatch.closest('.HorizontalList__Item');

    const unavailableSizes = parseUnavailableSizes(
      $swatch.attr('data-variants-no-inventory')
    );

    const isUnavailableForSelectedSize =
      !!selectedSize && unavailableSizes.includes(selectedSize);

    $item.toggleClass('is-size-unavailable', isUnavailableForSelectedSize);

    $swatch
      .toggleClass('Option__Unavailable', isUnavailableForSelectedSize)
      .attr('aria-disabled', isUnavailableForSelectedSize ? 'true' : 'false');
  });
}

function assignVariantUrls() {
  const selectedSize = getSelectedSizeValue();

  document.querySelectorAll('.product__color-swatches .ColorSwatch').forEach((swatch) => {
    const swatchUrl = swatch.getAttribute("href");

    if (!swatchUrl) {
      return;
    }

    const baseUrl = swatchUrl.split("?variant")[0];

    if (!selectedSize) {
      // Nessuna taglia scelta: niente variante nell'URL, così la pagina di destinazione
      // parte anche lei con "Seleziona una taglia"
      swatch.setAttribute("href", baseUrl);
      return;
    }

    const sizeToVariantMap = {};
    const sizeVariantIds = String(swatch.getAttribute('data-variants-ids') || '').split(",");

    sizeVariantIds.forEach((variant) => {
      const parts = variant.split(":");

      if (parts.length < 2) {
        return;
      }

      const size = normalizeVariantValue(parts[0]);
      const id = String(parts[1] || '').trim();

      if (size && id) {
        sizeToVariantMap[size] = id;
      }
    });

    const sizeVariantId = sizeToVariantMap[selectedSize];

    if (!sizeVariantId) {
      swatch.setAttribute("href", baseUrl);
      return;
    }

    const variantUrl = `${baseUrl}?variant=${sizeVariantId}`;

    swatch.setAttribute("href", variantUrl);
  });
}

function updateCurrentSizeFromVariant(variant) {
  const size = getVariantSizeValue(variant);

  if (size) {
    window.ragnoSelectedSizeFromVariant = size;

    try {
      sessionStorage.setItem('ragnoSelectedSize', size);
    } catch (error) {}
  }
}

function refreshColorSwatchesAfterThemeUpdate(event) {
  if (event && event.detail && event.detail.variant) {
    updateCurrentSizeFromVariant(event.detail.variant);
  }

  setTimeout(function () {
    assignVariantUrls();
    refreshColorSwatchesAvailability();
  }, 0);

  setTimeout(function () {
    assignVariantUrls();
    refreshColorSwatchesAvailability();
  }, 80);

  setTimeout(function () {
    assignVariantUrls();
    refreshColorSwatchesAvailability();
  }, 200);
}

$(document).ready(function () {
  var isProductPage = window.location.href.includes('/products');
  const isVariantUrl = window.location.href.includes('?variant=');

  if (!isProductPage) {
    return;
  }

  if (!window.theme || !window.theme.currentProduct || !window.theme.currentProduct.variants) {
    return;
  }

  var productSku = window.theme.currentProduct.variants[0].sku;
  var commonSku = productSku.split("_")[0];
  var productColor = '';

  for (let tag of window.theme.currentProduct.tags) {
    if (tag.includes('color_variant')) {
      productColor = tag.split(':')[1];
    }
  }

  var colorSwatchContainer = $('#color-selector-wrapper');

  if (!commonSku) {
    return;
  }

  var limit = 50;

  function fetchResults(page) {
    var url = `${window.routes.searchUrl}?q=${encodeURIComponent(commonSku)}&type=product&options%5Bfields%5D=variants.sku&options%5Bunavailable_products%5D=show&section_id=product-color-search&page=${page}`;

    return fetch(url).then(function (response) {
      if (!response.ok) {
        throw new Error(response.status);
      }

      return response.text();
    });
  }

  async function fetchAllColorSwatches() {
    let allResults = [];
    let page = 1;
    let hasMoreResults = true;
    let seenUrls = [];

    const currentProductTitle = window.theme.currentProduct?.title || '';
    const currentProductBaseName = currentProductTitle.split(' - ')[0].trim().toLowerCase();

    while (hasMoreResults) {
      const text = await fetchResults(page);
      const parser = new DOMParser().parseFromString(text, 'text/html');
      const section = parser.querySelector('#shopify-section-product-color-search');

      if (!section) {
        break;
      }

      const productLinks = section.querySelectorAll('a[data-action="change-color-variant"]');

      if (!productLinks.length) {
        break;
      }

      productLinks.forEach(function (link) {
        var ariaLabel = link.getAttribute('aria-label') || '';
        var productBaseName = ariaLabel.split(' - ')[0].trim().toLowerCase();
        var href = link.getAttribute('href') || '';

        if (productBaseName === currentProductBaseName && seenUrls.indexOf(href) === -1) {
          var listItem = link.closest('li');

          if (listItem) {
            allResults.push(listItem.outerHTML);
            seenUrls.push(href);
          }
        }
      });

      page++;

      if (page > 20) {
        hasMoreResults = false;
      }

      if (productLinks.length < limit) {
        hasMoreResults = false;
      }
    }

    return allResults;
  }

  fetchAllColorSwatches()
    .then(function (allResults) {
      if (!allResults.length) {
        console.warn('Nessuno swatch colore trovato per:', commonSku);
        return;
      }

      const allResultsMarkup = `
        <div class="product__color-swatches" data-product-swatches data-product-option="Option2">
          <ul class="ColorSwatchList HorizontalList HorizontalList--spacingTight">
            ${allResults.join('')}
          </ul>
        </div>
      `;

      $(colorSwatchContainer).append(allResultsMarkup);
      hideColorSwatchesWithoutAvailableSizes();
      clearInitialSizeSwatchSelection();

      const currentColorElement = $(colorSwatchContainer).find(
        `[data-color="${productColor.toLowerCase().replaceAll(" ", "_")}"]`
      );

      $(currentColorElement).addClass("current");

      // Caso URL con ?variant=ID: leggo subito la taglia da URL
      const sizeFromUrl = getSizeFromUrlVariant();

      if (sizeFromUrl) {
        window.ragnoSelectedSizeFromVariant = sizeFromUrl;

        try {
          sessionStorage.setItem('ragnoSelectedSize', sizeFromUrl);
        } catch (error) {}
      }

      if (!window.theme.isFirstVariantSelected) {
        if (!window.location.href.includes('?variant')) {
          $(".SizeSwatchList .js-radio-option").prop('checked', false);
          window.ragnoSelectedSizeFromVariant = '';

          try {
            sessionStorage.removeItem('ragnoSelectedSize');
          } catch (error) {}

          const noVariantSelected = document.querySelector('[data-action="no-variant"]');
          const errorMessage = document.querySelector('.add_to_cart_error');

          function handleNoQuantityClick(e) {
            e.preventDefault();

            if (errorMessage) {
              errorMessage.style.display = 'block';
            }
          }

          function handleVariantChange(event) {
            const errorMessageUnselectedVariant = document.querySelector('.add_to_cart_error');

            if (noVariantSelected) {
              noVariantSelected.removeEventListener('click', handleNoQuantityClick);
            }

            if (errorMessageUnselectedVariant) {
              errorMessageUnselectedVariant.style.display = 'none';
            }
          }

          if (noVariantSelected) {
            noVariantSelected.addEventListener('click', handleNoQuantityClick);
          }

          document.addEventListener('variant:changed', handleVariantChange);
        } else {
          const urlParams = new URLSearchParams(window.location.search);
          const variantId = urlParams.get('variant');

          const sizeVariant = getVariantByIdFromCurrentProduct(variantId);

          if (sizeVariant) {
            updateCurrentSizeFromVariant(sizeVariant);

            $(".SizeSwatchList .js-radio-option").filter(function () {
              return normalizeVariantValue($(this).val()) === getVariantSizeValue(sizeVariant);
            }).prop('checked', true);
          }
        }
      } else {
        const selectedVariantId = $('#product-select').val();
        const hasExplicitSizeSelection =
          !!$('.SizeSwatchList .js-radio-option:checked').length ||
          window.location.href.includes('?variant');

        if (selectedVariantId && hasExplicitSizeSelection) {
          const selectedVariant = getVariantByIdFromCurrentProduct(selectedVariantId);

          if (selectedVariant) {
            updateCurrentSizeFromVariant(selectedVariant);
          }
        }
      }

      const dataVariantsNoInventory = $(currentColorElement).attr('data-variants-no-inventory');
      let sizeVariantQuantities = [];

      if (dataVariantsNoInventory !== '' && dataVariantsNoInventory !== undefined) {
        sizeVariantQuantities = parseUnavailableSizes(dataVariantsNoInventory);
      }

      assignVariantUrls();
      refreshColorSwatchesAvailability();
      refreshSizeSwatchesAvailability(sizeVariantQuantities, ".SizeSwatchList");

      $(document)
        .off('change.colorSwatches')
        .on('change.colorSwatches', '.SizeSwatchList .js-radio-option, .js-radio-option, #product-select', function () {
          const currentSize = $(this).val();

          if (currentSize) {
            window.ragnoSelectedSizeFromVariant = normalizeVariantValue(currentSize);

            try {
              sessionStorage.setItem('ragnoSelectedSize', normalizeVariantValue(currentSize));
            } catch (error) {}
          }

          assignVariantUrls();
          refreshColorSwatchesAvailability();
          refreshSizeSwatchesAvailability(sizeVariantQuantities, ".SizeSwatchList");

          if (typeof window.ragnoApplySizeMapping === 'function') {
            setTimeout(window.ragnoApplySizeMapping, 0);
            setTimeout(window.ragnoApplySizeMapping, 80);
          }
        });

      document.addEventListener('variant:changed', refreshColorSwatchesAfterThemeUpdate);

      document.addEventListener('click', function (event) {
        const optionButton = event.target.closest('.Popover__Value[data-action="select-value"]');

        if (!optionButton) {
          return;
        }

        const optionValue =
          optionButton.getAttribute('data-value') ||
          optionButton.getAttribute('value') ||
          optionButton.textContent;

        if (optionValue) {
          window.ragnoSelectedSizeFromVariant = normalizeVariantValue(optionValue);

          try {
            sessionStorage.setItem('ragnoSelectedSize', normalizeVariantValue(optionValue));
          } catch (error) {}
        }

        setTimeout(function () {
          assignVariantUrls();
          refreshColorSwatchesAvailability();
        }, 80);

        setTimeout(function () {
          assignVariantUrls();
          refreshColorSwatchesAvailability();
        }, 200);
      });

      var colorSwatches = document.querySelectorAll('[data-action="change-color-variant"]');

      if (colorSwatches.length > 0 && window.history && window.history.replaceState) {
        colorSwatches.forEach(function (colorSwatch) {
          colorSwatch.addEventListener('click', function (e) {
            var target = e.currentTarget;

            const selectedSize = getSelectedSizeValue();

            if (selectedSize) {
              window.ragnoSelectedSizeFromVariant = selectedSize;

              try {
                sessionStorage.setItem('ragnoSelectedSize', selectedSize);
              } catch (error) {}
            }

            if (!history.replaceState) {
              return;
            }

            var url = target.getAttribute('href');

            if (!url) {
              return;
            }

            var newUrl = "".concat(window.location.protocol, "//").concat(window.location.host).concat(url);

            window.history.replaceState({ path: newUrl }, '', newUrl);
          });
        });
      }

      // Refresh finale dopo eventuali update del tema
      setTimeout(function () {
        assignVariantUrls();
        refreshColorSwatchesAvailability();
      }, 250);
    })
    .catch(function (error) {
      console.log(error);
    });
});
document.addEventListener('variant:changed', function (e) {
  var btn = document.getElementById('AddToCartButton');

  if (!btn) return;

  var variant = e.detail && e.detail.variant;

  if (!variant) return;

  var labelSpan = btn.querySelector('span');

  if (variant.available) {
    btn.removeAttribute('disabled');
    btn.setAttribute('data-action', 'add-to-cart');
    btn.classList.remove('Button--secondary');
    btn.classList.add('Button--primary');

    if (labelSpan) {
      labelSpan.textContent = labelSpan.getAttribute('data-add-to-cart-label') || labelSpan.textContent;
    }
  } else {
    btn.setAttribute('disabled', 'disabled');
    btn.removeAttribute('data-action');
    btn.classList.remove('Button--primary');
    btn.classList.add('Button--secondary');

    if (labelSpan) {
      labelSpan.textContent = labelSpan.getAttribute('data-sold-out-label') || labelSpan.textContent;
    }
  }
});
document.addEventListener('click', function (e) {
  var btn = e.target.closest('#AddToCartButton[data-action="no-variant"]');

  if (!btn) return;

  e.preventDefault();

  var sizeTrigger = document.querySelector('.ProductForm__Item--anchored');

  if (sizeTrigger) {
    sizeTrigger.click();
  }
});

/* Funzione per popolare ab testing */
(function () {
  if (!window.routes || !window.routes.searchUrl) return;
  if (!document.querySelector('.ProductList')) return; // solo pagine collezione/PLP

  var PAGE_LIMIT = 50;
  var MAX_PAGES = 20;

  /*
   * commonSku + baseName -> Promise<Array siblings>
   */
  var cache = {};

  function normalizeBaseName(title) {
    return String(title || '')
      .split(' - ')[0]
      .trim()
      .toLowerCase();
  }

  function normalizeUrl(url) {
    var value = String(url || '')
      .replace(/&amp;/g, '&')
      .trim();

    if (!value) return '';

    /*
     * Evita placeholder trasparenti eventualmente usati
     * dal lazy loading.
     */
    if (
      value.indexOf('data:image') === 0 ||
      value.indexOf('data:application') === 0
    ) {
      return '';
    }

    if (value.indexOf('//') === 0) {
      return window.location.protocol + value;
    }

    /*
     * Le immagini Shopify sono normalmente assolute.
     * Se arriva un URL relativo, lo trasformiamo in assoluto.
     */
    try {
      return new URL(value, window.location.origin).href;
    } catch (error) {
      return value;
    }
  }

  function getCardData(card) {
    var raw = card.getAttribute('data-productinfo') || '';

    var sku = '';
    var itemName = '';

    /*
    * Caso normale: JSON valido.
    */
    if (raw) {
      try {
        var info = JSON.parse(raw);

        sku = info.item_sku || '';
        itemName = info.item_name || '';
      } catch (error) {
        /*
        * Il JSON può essere stato troncato dal markup HTML,
        * ad esempio per un apostrofo nel titolo prodotto.
        *
        * Lo SKU normalmente compare prima del titolo e quindi
        * possiamo comunque recuperarlo.
        */
        var skuMatch = raw.match(
          /["']item_sku["']\s*:\s*["']([^"']+)["']/i
        );

        if (skuMatch) {
          sku = skuMatch[1];
        }

        console.warn(
          'Invalid data-productinfo, using DOM fallback:',
          raw,
          error
        );
      }
    }

    /*
    * Per il nome prodotto preferiamo comunque il titolo reale
    * presente nella card se il JSON non è utilizzabile.
    */
    if (!itemName) {
      var titleElement = card.querySelector(
        '.ProductItem__Title a'
      );

      if (titleElement) {
        itemName = titleElement.textContent.trim();
      }
    }

    if (!sku || !itemName) {
      return null;
    }

    return {
      commonSku: String(sku).split('_')[0],
      baseName: normalizeBaseName(itemName)
    };
  }

  function extractUrlFromSrcset(srcset) {
    var candidates = String(srcset || '')
      .split(',')
      .map(function (candidate) {
        return candidate.trim();
      })
      .filter(Boolean);

    if (!candidates.length) {
      return '';
    }

    /*
     * Nei srcset Shopify i formati sono normalmente ordinati
     * dal più piccolo al più grande: prendiamo l'ultimo.
     */
    var largestCandidate = candidates[candidates.length - 1];

    return normalizeUrl(
      largestCandidate.split(/\s+/)[0]
    );
  }

  function extractImageFromElement(imageElement) {
    if (!imageElement) return '';

    var attributes = [
      'data-image-url',
      'data-src',
      'data-original',
      'data-lazy-src',
      'data-master',
      'src'
    ];

    for (var i = 0; i < attributes.length; i++) {
      var value = normalizeUrl(
        imageElement.getAttribute(attributes[i])
      );

      if (value) {
        return value;
      }
    }

    var srcset =
      imageElement.getAttribute('data-srcset') ||
      imageElement.getAttribute('srcset');

    return extractUrlFromSrcset(srcset);
  }

  function extractProductImage(link) {
    if (!link) return '';

    /*
     * Fonte principale:
     * attributo stampato direttamente dalla sezione Liquid.
     */
    var directAttributes = [
      'data-image-url',
      'data-product-image',
      'data-featured-image',
      'data-image'
    ];

    for (var i = 0; i < directAttributes.length; i++) {
      var directValue = normalizeUrl(
        link.getAttribute(directAttributes[i])
      );

      if (directValue) {
        return directValue;
      }
    }

    /*
     * Fallback: nel caso in cui la sezione di ricerca contenga
     * una card prodotto completa oltre allo swatch.
     */
    var productContainer = link.closest(
      [
        '.ProductItem',
        '[data-product-item]',
        '[data-product-card]',
        '.product-card',
        '.product-item',
        'article'
      ].join(',')
    );

    if (productContainer) {
      var productImage = productContainer.querySelector(
        [
          '.ProductItem__ImageWrapper img',
          'img.ProductItem__Image',
          '[data-product-image] img',
          'img[data-image-url]',
          'img[data-src]',
          'img[data-srcset]',
          'img[srcset]',
          'img[src]'
        ].join(',')
      );

      var productImageUrl = extractImageFromElement(productImage);

      if (productImageUrl) {
        return productImageUrl;
      }
    }

    /*
     * Ultimo fallback: immagine eventualmente presente
     * direttamente dentro al link.
     */
    return extractImageFromElement(
      link.querySelector('img')
    );
  }

  function extractHexOrSwatchImage(link) {
    if (!link) {
      return {
        hex: '',
        swatchImage: ''
      };
    }

    /*
     * Nel markup reale lo style si trova sull'a.ColorSwatch,
     * non sul label.
     */
    var styleStr = link.getAttribute('style') || '';

    /*
     * Manteniamo un fallback sul label per eventuali markup
     * precedenti o differenti.
     */
    if (!styleStr && link.parentElement) {
      var label = link.parentElement.querySelector(
        'label.ColorSwatch'
      );

      styleStr = label
        ? label.getAttribute('style') || ''
        : '';
    }

    var hexMatch = styleStr.match(
      /background-color\s*:\s*(#[0-9a-fA-F]{3,8})/i
    );

    var imageMatch = styleStr.match(
      /background-image\s*:\s*url\(\s*(['"]?)(.*?)\1\s*\)/i
    );

    return {
      hex: hexMatch ? hexMatch[1] : '',
      swatchImage: imageMatch
        ? normalizeUrl(imageMatch[2])
        : ''
    };
  }

  function fetchResultsPage(commonSku, page) {
    var url =
      window.routes.searchUrl +
      '?q=' +
      encodeURIComponent(commonSku) +
      '&type=product' +
      '&options%5Bfields%5D=variants.sku' +
      '&options%5Bunavailable_products%5D=show' +
      '&section_id=product-color-search' +
      '&page=' +
      page;

    return fetch(url).then(function (response) {
      if (!response.ok) {
        throw new Error(
          'Search request failed: ' + response.status
        );
      }

      return response.text();
    });
  }

  function fetchAllColorsForModel(commonSku, baseName) {
    var seenUrls = [];
    var results = [];

    function loadPage(page) {
      return fetchResultsPage(commonSku, page).then(function (text) {
        var parser = new DOMParser().parseFromString(
          text,
          'text/html'
        );

        var section = parser.querySelector(
          '#shopify-section-product-color-search'
        );

        if (!section) {
          return false;
        }

        var links = section.querySelectorAll(
          'a[data-action="change-color-variant"]'
        );

        if (!links.length) {
          return false;
        }

        links.forEach(function (link) {
          var ariaLabel =
            link.getAttribute('aria-label') || '';

          var linkBaseName = normalizeBaseName(
            ariaLabel
          );

          var href =
            link.getAttribute('href') || '';

          /*
           * Per evitare duplicati dovuti a variant differenti,
           * il controllo viene effettuato sull'URL completo
           * ricevuto dalla sezione.
           */
          if (
            linkBaseName !== baseName ||
            !href ||
            seenUrls.indexOf(href) !== -1
          ) {
            return;
          }

          seenUrls.push(href);

          var swatchData =
            extractHexOrSwatchImage(link);

          results.push({
            color:
              link.getAttribute('data-color') || '',

            url: href,

            /*
             * Prima immagine del prodotto/combinazione colore.
             */
            image: extractProductImage(link),

            /*
             * Colore esadecimale, quando realmente presente.
             */
            hex: swatchData.hex,

            /*
             * Immagine campione colore presa dal
             * background-image dello swatch.
             */
            swatchImage: swatchData.swatchImage
          });
        });

        return links.length >= PAGE_LIMIT;
      });
    }

    var page = 1;

    function next() {
      return loadPage(page).then(function (hasMore) {
        page++;

        if (
          hasMore &&
          page <= MAX_PAGES
        ) {
          return next();
        }

        return results;
      });
    }

    return next();
  }

  function getSiblingsForSku(commonSku, baseName) {
    var cacheKey =
      commonSku + '|' + baseName;

    if (!cache[cacheKey]) {
      cache[cacheKey] =
        fetchAllColorsForModel(
          commonSku,
          baseName
        ).catch(function (error) {
          console.warn(
            'Color AB test fetch failed for',
            commonSku,
            error
          );

          return [];
        });
    }

    return cache[cacheKey];
  }

  function buildHiddenContainer(card, siblings) {
    var existing = card.querySelector(
      ':scope > [data-color-ab-data]'
    );

    if (existing) {
      existing.remove();
    }

    var container =
      document.createElement('div');

    container.setAttribute(
      'data-color-ab-data',
      ''
    );

    container.setAttribute(
      'hidden',
      'hidden'
    );

    container.setAttribute(
      'aria-hidden',
      'true'
    );

    siblings.forEach(function (sibling) {
      var item =
        document.createElement('div');

      item.className =
        'js-color-ab-item';

      item.setAttribute(
        'data-color',
        sibling.color
      );

      item.setAttribute(
        'data-url',
        sibling.url
      );

      item.setAttribute(
        'data-image',
        sibling.image || ''
      );

      /*
       * Viene inserito l'esadecimale quando disponibile.
       */
      if (sibling.hex) {
        item.setAttribute(
          'data-hex',
          sibling.hex
        );
      }

      /*
       * In alternativa, o anche insieme all'esadecimale,
       * viene inserita l'immagine della colorazione.
       */
      if (sibling.swatchImage) {
        item.setAttribute(
          'data-swatch-image',
          sibling.swatchImage
        );
      }

      container.appendChild(item);
    });

    card.appendChild(container);
  }

  function handleCard(card) {
    var data = getCardData(card);

    if (!data) return;

    getSiblingsForSku(
      data.commonSku,
      data.baseName
    ).then(function (siblings) {
      if (!siblings.length) return;

      buildHiddenContainer(
        card,
        siblings
      );
    });
  }

  var cardObserver = null;
  var productListObserver = null;

  function observeCard(card) {
    if (!card) return;

    /*
    * Evita di registrare più volte la stessa card.
    *
    * Questo attributo serve solo per sapere che la card
    * è già stata affidata all'IntersectionObserver.
    */
    if (card.hasAttribute('data-color-ab-initialized')) {
      return;
    }

    card.setAttribute('data-color-ab-initialized', 'true');

    /*
    * Browser senza IntersectionObserver:
    * elaborazione immediata.
    */
    if (!('IntersectionObserver' in window)) {
      handleCard(card);
      return;
    }

    cardObserver.observe(card);
  }

  function scanCards(root) {
    root = root || document;

    /*
    * Caso in cui il nodo appena aggiunto sia esso stesso
    * una ProductItem.
    */
    if (
      root.nodeType === 1 &&
      root.matches &&
      root.matches('.ProductItem[data-productinfo]')
    ) {
      observeCard(root);
    }

    /*
    * Cerca eventuali ProductItem contenute nel nodo aggiunto.
    */
    if (!root.querySelectorAll) return;

    var cards = root.querySelectorAll(
      '.ProductItem[data-productinfo]'
    );

    cards.forEach(function (card) {
      observeCard(card);
    });
  }

  function init() {
    /*
    * IntersectionObserver unico e persistente.
    *
    * Serve sia per le card presenti al caricamento
    * sia per quelle inserite successivamente da:
    *
    * - filtri
    * - ordinamento
    * - infinite scroll
    * - AJAX
    */
    if ('IntersectionObserver' in window) {
      cardObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) {
              return;
            }

            cardObserver.unobserve(entry.target);

            handleCard(entry.target);
          });
        },
        {
          rootMargin: '200px 0px'
        }
      );
    }

    /*
    * Card presenti al primo caricamento.
    */
    scanCards(document);

    /*
    * Osserva l'inserimento di nuove card.
    */
    productListObserver = new MutationObserver(
      function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) {
              return;
            }

            scanCards(node);
          });
        });
      }
    );

    /*
    * Importante:
    *
    * non osserviamo direttamente .ProductList perché
    * filtri/sort potrebbero sostituire completamente quel nodo.
    *
    * Cerchiamo quindi un parent che sopravviva al refresh AJAX.
    */
    var observerRoot =
      document.querySelector('#shopify-section-collection-template') ||
      document.querySelector('[id^="shopify-section-"][class*="collection"]') ||
      document.querySelector('main') ||
      document.body;

    productListObserver.observe(observerRoot, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }
})();


function swymCallbackFn(swat) {
  function swymAttachEvents() {
    swat.initializeActionButtons("body");
  }

  document.addEventListener('variant:changed', function (event) {
    var variant_id = event.detail.variant.id;
    var btn = document.querySelector("#swym-pdp-button");
    if (btn) {
      btn.setAttribute("data-variant-id", variant_id);
    }
    swymAttachEvents();
  });
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCallbackFn);

//Collection description
if (window.location.href.indexOf('collections') > -1) {
  readMore('collection');
}
else if (window.location.href.indexOf('products') > -1) {
  readMore('product');
}

function readMore(context) {
  let read_more = document.getElementById('read-more');
  let read_less = document.getElementById('read-less');
  let truncated_description = '';
  let full_description = '';
  if (context == 'product') {
    truncated_description = document.getElementById('truncated-product-description');
    full_description = document.getElementById('full-product-description');
  }

  if (read_more && read_less) {
    read_more.addEventListener('click', showHideDescription);
    read_less.addEventListener('click', showHideDescription);
  }

  function showHideDescription() {
    let ID = this.id;
    if (ID === "read-more") {
      truncated_description.style.display = "none";
      full_description.style.display = "block";
    } else {
      truncated_description.style.display = "block";
      full_description.style.display = "none";
    }
  }
}

if(window.location.href.indexOf('collections') > -1){
  const read_more = document.querySelector('#read-more');
  const collectionDescription = document.querySelector('#collection-description');

  // add class hide to read_more and class open to collectionDescription
    if(read_more && collectionDescription){
      read_more.addEventListener('click', function(){
        if(collectionDescription.classList.contains('open')){
          collectionDescription.classList.remove('open');
          read_more.textContent = window.languages.readMore;
          return;
        }
        collectionDescription.classList.add('open');
        read_more.textContent = window.languages.readLess;
      })
    }
}

const showHideMenu = (clickedElParent, clickedElTarget) => {
  $(clickedElParent).addClass('is-main-nav-active');
  $(clickedElParent).siblings().removeClass('is-main-nav-active');

  const correspondingSubMenu = document.querySelector(`.${CSS.escape(clickedElTarget)}`);

  if (correspondingSubMenu) {
    $(correspondingSubMenu).siblings().attr('aria-hidden', 'true');
    $(correspondingSubMenu).attr('aria-hidden', 'false');

    const subMenuItems = document.querySelectorAll('.Header__MainNav .HorizontalList__Item');

    subMenuItems.forEach(el => {
      if (!el.parentNode.classList.contains('is-main-nav-active')) {
        el.classList.remove('is-expanded');

        const children = el.querySelectorAll('[aria-hidden="false"]');

        children.forEach(child => {
          child.setAttribute('aria-hidden', 'true');
        });
      }
    });
  }
};

$('document').ready(function () {
  const isOptinPage = window.location.href.includes('optin-zodiaco');
  if (isOptinPage) return;

  const links = document.querySelectorAll('.Header__MainNav__Link');
  const header = document.querySelector('.Header__Wrapper');

  let lastOpenedSubmenuLink = null;
  let lastShiftTabPanel = null;

  const isDesktopHover = () =>
    window.matchMedia('(hover: hover) and (pointer: fine)').matches ||
    window.innerWidth >= 1024;

  function getFocusableElements(container) {
    if (!container) return [];

    return Array.from(container.querySelectorAll(`
      a[href],
      button:not([disabled]),
      input:not([disabled]),
      select:not([disabled]),
      textarea:not([disabled]),
      [tabindex]:not([tabindex="-1"])
    `)).filter(el => {
      return !el.hasAttribute('disabled') &&
        el.offsetParent !== null &&
        el.getAttribute('aria-hidden') !== 'true' &&
        !el.closest('[aria-hidden="true"]');
    });
  }

  function getSubmenuRootFromList(ul) {
    return ul?.closest('.Header__MainNav__Submenu');
  }

  function getPanelsWrapFromList(ul) {
    const submenuRoot = getSubmenuRootFromList(ul);

    return submenuRoot?.querySelector('.Header__SubmenuPanels') || null;
  }

  function getPanelById(ul, id) {
    const panelsWrap = getPanelsWrapFromList(ul);
    if (!panelsWrap || !id) return null;

    return panelsWrap.querySelector(
      `[data-submenu-panel][data-submenu-id="${CSS.escape(id)}"]`
    );
  }

  function hasMeaningfulPanelContent(ul, id) {
    const panel = getPanelById(ul, id);

    return !!(panel && (
      (panel.textContent && panel.textContent.trim().length > 0) ||
      panel.querySelector('.MegaMenu, .MegaMenu__Inner, .Linklist, a, img, video, picture, svg, ul, li')
    ));
  }

  function hasMainSubmenuContent(submenu) {
    if (!submenu) return false;

    return !!(
      submenu.querySelector('a[href], button:not([disabled]), [data-submenu-item], [data-submenu-panel]') ||
      (submenu.textContent && submenu.textContent.trim().length > 0)
    );
  }

  function ensurePanelId(panel, id, index) {
    if (!panel) return null;

    if (!panel.id) {
      panel.id = `submenu-panel-${id}-${index}`;
    }

    return panel.id;
  }

  function getSubmenuLinkFromItem(item) {
    if (!item) return null;

    if (item.matches('a[href]')) {
      return item;
    }

    return item.querySelector('a[href]');
  }

  function getItemLabel(item) {
    const link = getSubmenuLinkFromItem(item);
    const label = link?.textContent?.trim() || item.textContent?.trim() || 'Sottomenu';

    return label.replace(/\s+/g, ' ');
  }

  function getChevronSvg() {
    return `
      <span class="Header__SubmenuChevron" aria-hidden="true">
        <svg viewBox="0 0 24 24" width="1em" height="1em" fill="currentColor" focusable="false">
          <path d="M2.859 7.475a.75.75 0 0 1 1.06 0l7.55 7.55a.75.75 0 0 0 1.06 0l7.551-7.55a.75.75 0 1 1 1.061 1.06l-7.55 7.55a2.25 2.25 0 0 1-3.182 0l-7.55-7.55a.75.75 0 0 1 0-1.06"></path>
        </svg>
      </span>
    `;
  }

  function enhanceLinkWithChevron(link, options = {}) {
    if (!link || link.querySelector('.Header__SubmenuChevron')) return;

    const {
      controls = null,
      label = null,
      expanded = 'false',
    } = options;

    link.classList.add('has-submenu-chevron');
    link.setAttribute('aria-expanded', expanded);
    link.setAttribute('aria-haspopup', 'true');

    if (controls) {
      link.setAttribute('aria-controls', controls);
    }

    if (label && !link.getAttribute('aria-label')) {
      link.setAttribute('aria-label', `${label}, Menù`);
    }

    link.insertAdjacentHTML('beforeend', getChevronSvg());
  }

  function removeChevronFromLink(link) {
    if (!link) return;

    link.classList.remove('has-submenu-chevron');
    link.removeAttribute('aria-expanded');
    link.removeAttribute('aria-haspopup');
    link.removeAttribute('aria-controls');

    const chevron = link.querySelector('.Header__SubmenuChevron');
    if (chevron) chevron.remove();
  }

  function injectMainNavChevrons() {
    links.forEach(link => {
      const target = link.dataset.target;

      if (!target) {
        removeChevronFromLink(link);
        return;
      }

      const submenu = document.querySelector(`.${CSS.escape(target)}`);

      if (!hasMainSubmenuContent(submenu)) {
        removeChevronFromLink(link);
        return;
      }

      if (!submenu.id) {
        submenu.id = `main-submenu-${target}`;
      }

      const label = link.textContent?.trim()?.replace(/\s+/g, ' ');

      enhanceLinkWithChevron(link, {
        controls: submenu.id,
        label,
        expanded: 'false',
      });
    });
  }

  function injectSubmenuChevrons() {
    document.querySelectorAll('.Header__MainNav__Submenu').forEach(submenuRoot => {
      const ul = submenuRoot.querySelector('.Header__SubmenuList');
      if (!ul) return;

      const items = ul.querySelectorAll('[data-submenu-item][data-submenu-id]');

      items.forEach((item, index) => {
        const id = item.getAttribute('data-submenu-id');
        if (!id) return;

        const hasPanel = hasMeaningfulPanelContent(ul, id);

        if (!hasPanel) {
          item.classList.remove('has-submenu-chevron');

          const link = getSubmenuLinkFromItem(item);
          if (link) {
            link.removeAttribute('data-submenu-link-id');
            removeChevronFromLink(link);
          }

          return;
        }

        const link = getSubmenuLinkFromItem(item);
        if (!link) return;

        const panel = getPanelById(ul, id);
        const panelId = ensurePanelId(panel, id, index);
        const label = getItemLabel(item);

        item.classList.add('has-submenu-chevron');

        link.setAttribute('data-submenu-link-id', id);

        enhanceLinkWithChevron(link, {
          controls: panelId,
          label,
          expanded: 'false',
        });
      });
    });
  }

  function setPanelInnerVisibility(panel, isVisible) {
    if (!panel) return;

    panel.setAttribute('aria-hidden', isVisible ? 'false' : 'true');

    Array.from(panel.children).forEach(child => {
      if (
        child.matches('.MegaMenu') ||
        child.matches('.DropdownMenu')
      ) {
        child.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
      }
    });

    if (!isVisible) {
      panel.querySelectorAll('.MegaMenu, .DropdownMenu').forEach(child => {
        child.setAttribute('aria-hidden', 'true');
      });
    }
  }

  function disablePanelFocus(panel) {
    if (!panel) return;

    panel.querySelectorAll(`
      a[href],
      button:not([disabled]),
      input:not([disabled]),
      select:not([disabled]),
      textarea:not([disabled]),
      [tabindex]:not([tabindex="-1"])
    `).forEach(el => {
      if (!el.hasAttribute('data-original-tabindex')) {
        const original = el.getAttribute('tabindex');

        el.setAttribute(
          'data-original-tabindex',
          original === null ? '' : original
        );
      }

      el.setAttribute('tabindex', '-1');
    });
  }

  function restorePanelFocus(panel) {
    if (!panel) return;

    panel.querySelectorAll('[data-original-tabindex]').forEach(el => {
      const original = el.getAttribute('data-original-tabindex');

      if (original === '') {
        el.removeAttribute('tabindex');
      } else {
        el.setAttribute('tabindex', original);
      }

      el.removeAttribute('data-original-tabindex');
    });
  }

  function updateMainNavExpandedStates() {
    links.forEach(link => {
      const parentLi = link.parentNode;
      const isExpanded = parentLi?.classList.contains('is-main-nav-active');

      if (link.hasAttribute('aria-expanded')) {
        link.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      }
    });
  }

  function focusFirstSubmenuItem(linkEl) {
    const target = linkEl.dataset.target;
    if (!target) return false;

    const submenu = document.querySelector(`.${CSS.escape(target)}`);

    if (!submenu || submenu.getAttribute('aria-hidden') === 'true') {
      return false;
    }

    const submenuList = submenu.querySelector('.Header__SubmenuList');
    const focusables = getFocusableElements(submenuList || submenu);

    if (!focusables.length) return false;

    focusables[0].focus();
    return true;
  }

  function getActiveSubmenuLinkForPanel(panel) {
    if (!panel) return null;

    const id = panel.getAttribute('data-submenu-id');
    if (!id) return null;

    const submenuRoot = panel.closest('.Header__MainNav__Submenu');
    if (!submenuRoot) return null;

    return submenuRoot.querySelector(
      `[data-submenu-link-id="${CSS.escape(id)}"]`
    );
  }

  function setActiveSecondLevelItem(item, options = {}) {
    if (!item) return;

    const ul = item.closest('.Header__SubmenuList');
    if (!ul) return;

    const {
      deactivatePanels = false,
    } = options;

    ul.querySelectorAll('[data-submenu-item].is-submenu-active')
      .forEach(x => x.classList.remove('is-submenu-active'));

    item.classList.add('is-submenu-active');

    const id = item.getAttribute('data-submenu-id');

    if (id) {
      ul.setAttribute('data-active-submenu-id', id);
    }

    if (deactivatePanels) {
      deactivateAllPanels(ul, {
        keepActiveItem: true,
      });
    }
  }

  function deactivateAllPanels(ul, options = {}) {
    const panelsWrap = getPanelsWrapFromList(ul);
    if (!panelsWrap) return;

    const {
      keepActiveItem = false,
    } = options;

    panelsWrap.querySelectorAll('[data-submenu-panel]').forEach(panel => {
      panel.classList.remove('is-active');
      setPanelInnerVisibility(panel, false);
      disablePanelFocus(panel);
    });

    ul.querySelectorAll('[data-submenu-link-id][aria-expanded]').forEach(link => {
      link.setAttribute('aria-expanded', 'false');
    });

    if (!keepActiveItem) {
      ul.querySelectorAll('[data-submenu-item].is-submenu-active')
        .forEach(item => item.classList.remove('is-submenu-active'));

      ul.removeAttribute('data-active-submenu-id');
    }

    if (lastOpenedSubmenuLink && ul.contains(lastOpenedSubmenuLink)) {
      lastOpenedSubmenuLink = null;
    }
  }

  function activatePanel(ul, id, options = {}) {
    if (!ul || !id) return;

    const { moveFocus = false, openerLink = null } = options;

    const panelsWrap = getPanelsWrapFromList(ul);
    if (!panelsWrap) return;

    panelsWrap.querySelectorAll('[data-submenu-panel]').forEach(panel => {
      panel.classList.remove('is-active');
      setPanelInnerVisibility(panel, false);
      disablePanelFocus(panel);
    });

    const targetPanel = panelsWrap.querySelector(
      `[data-submenu-panel][data-submenu-id="${CSS.escape(id)}"]`
    );

    if (targetPanel) {
      targetPanel.classList.add('is-active');
      setPanelInnerVisibility(targetPanel, true);
      restorePanelFocus(targetPanel);
    }

    const activeItem = ul.querySelector(
      `[data-submenu-item][data-submenu-id="${CSS.escape(id)}"]`
    );

    if (activeItem) {
      setActiveSecondLevelItem(activeItem);
    }

    ul.setAttribute('data-active-submenu-id', id);

    ul.querySelectorAll('[data-submenu-link-id][aria-expanded]').forEach(link => {
      const isCurrent = link.getAttribute('data-submenu-link-id') === id;
      link.setAttribute('aria-expanded', isCurrent ? 'true' : 'false');

      if (isCurrent) {
        lastOpenedSubmenuLink = openerLink || link;
      }
    });

    if (moveFocus && targetPanel) {
      const focusables = getFocusableElements(targetPanel);

      if (focusables.length) {
        focusables[0].focus();
      } else {
        targetPanel.setAttribute('tabindex', '-1');
        targetPanel.focus();
      }
    }
  }

  function togglePanelFromLink(link, ul, options = {}) {
    const id = link.getAttribute('data-submenu-link-id');
    if (!id) return;

    const isExpanded = link.getAttribute('aria-expanded') === 'true';
    const { moveFocus = true } = options;

    if (isExpanded) {
      link.setAttribute('aria-expanded', 'false');

      const panel = getPanelById(ul, id);

      if (panel) {
        panel.classList.remove('is-active');
        setPanelInnerVisibility(panel, false);
        disablePanelFocus(panel);
      }

      ul.removeAttribute('data-active-submenu-id');

      if (lastOpenedSubmenuLink === link) {
        lastOpenedSubmenuLink = null;
      }

      return;
    }

    activatePanel(ul, id, {
      moveFocus,
      openerLink: link,
    });
  }

  function closeAllMenus() {
    document
      .querySelectorAll('.Header__MainNav .HorizontalList__Item.is-main-nav-active')
      .forEach(li => li.classList.remove('is-main-nav-active'));

    links.forEach(link => {
      const target = link.dataset.target;
      if (!target) return;

      const sub = document.querySelector(`.${CSS.escape(target)}`);
      if (sub) sub.setAttribute('aria-hidden', 'true');
    });

    document
      .querySelectorAll('.Header__MainNav .HorizontalList__Item.is-expanded')
      .forEach(li => {
        li.classList.remove('is-expanded');

        li.querySelectorAll('[aria-hidden="false"]').forEach(child => {
          child.setAttribute('aria-hidden', 'true');
        });
      });

    document
      .querySelectorAll('.Header__SubmenuList .HorizontalList__Item.is-submenu-active')
      .forEach(li => li.classList.remove('is-submenu-active'));

    document
      .querySelectorAll('.Header__MainNav__Submenu [data-submenu-item].is-submenu-active')
      .forEach(item => item.classList.remove('is-submenu-active'));

    document
      .querySelectorAll('.Header__SubmenuPanels [data-submenu-panel]')
      .forEach(panel => {
        panel.classList.remove('is-active');
        setPanelInnerVisibility(panel, false);
        disablePanelFocus(panel);
      });

    document
      .querySelectorAll('[data-submenu-link-id][aria-expanded="true"]')
      .forEach(link => {
        link.setAttribute('aria-expanded', 'false');
      });

    document
      .querySelectorAll('.Header__SubmenuList')
      .forEach(ul => {
        ul.removeAttribute('data-active-submenu-id');
      });

    lastOpenedSubmenuLink = null;
    lastShiftTabPanel = null;

    updateMainNavExpandedStates();
  }

  function openMenuForLink(linkEl, options = {}) {
    const target = linkEl.dataset.target;
    if (!target) return;

    const { moveFocus = false } = options;

    document
      .querySelectorAll('.Header__SubmenuList .HorizontalList__Item.is-submenu-active')
      .forEach(li => li.classList.remove('is-submenu-active'));

    document
      .querySelectorAll('.Header__MainNav__Submenu [data-submenu-item].is-submenu-active')
      .forEach(item => item.classList.remove('is-submenu-active'));

    document
      .querySelectorAll('.Header__SubmenuPanels [data-submenu-panel]')
      .forEach(panel => {
        panel.classList.remove('is-active');
        setPanelInnerVisibility(panel, false);
        disablePanelFocus(panel);
      });

    document
      .querySelectorAll('[data-submenu-link-id][aria-expanded="true"]')
      .forEach(link => {
        link.setAttribute('aria-expanded', 'false');
      });

    document
      .querySelectorAll('.Header__SubmenuList')
      .forEach(ul => {
        ul.removeAttribute('data-active-submenu-id');
      });

    lastOpenedSubmenuLink = null;
    lastShiftTabPanel = null;

    showHideMenu(linkEl.parentNode, target);
    updateMainNavExpandedStates();

    if (moveFocus) {
      window.requestAnimationFrame(() => {
        focusFirstSubmenuItem(linkEl);
      });
    }
  }

  function handleSecondLevelItemFocusOrHover(item, options = {}) {
    if (!item) return;

    const ul = item.closest('.Header__SubmenuList');
    if (!ul) return;

    const id = item.getAttribute('data-submenu-id');
    const link = getSubmenuLinkFromItem(item);

    setActiveSecondLevelItem(item);

    if (!id || !hasMeaningfulPanelContent(ul, id)) {
      deactivateAllPanels(ul, {
        keepActiveItem: true,
      });

      return;
    }

    if (options.openPanel) {
      activatePanel(ul, id, {
        moveFocus: false,
        openerLink: link,
      });
    }
  }

  injectMainNavChevrons();
  injectSubmenuChevrons();

  document.querySelectorAll('.Header__SubmenuPanels [data-submenu-panel]').forEach(panel => {
    setPanelInnerVisibility(panel, false);
    disablePanelFocus(panel);
  });

  if (isDesktopHover()) {
    closeAllMenus();

    links.forEach(el => {
      el.addEventListener('mouseenter', function (e) {
        openMenuForLink(e.currentTarget, { moveFocus: false });
      });

      el.addEventListener('focus', function () {
        // Non apre automaticamente.
      });

      el.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;

        const target = e.currentTarget.dataset.target;
        if (!target) return;

        const parentLi = e.currentTarget.parentNode;
        const isAlreadyOpen = parentLi.classList.contains('is-main-nav-active');

        if (!isAlreadyOpen) {
          e.preventDefault();

          openMenuForLink(e.currentTarget, { moveFocus: true });

          return;
        }

        if (e.key === ' ') {
          e.preventDefault();

          openMenuForLink(e.currentTarget, { moveFocus: true });
        }
      });

      el.addEventListener('click', e => {
        const href = e.currentTarget.getAttribute('href');
        const target = e.currentTarget.dataset.target;

        if (!target) return;

        const parentLi = e.currentTarget.parentNode;
        const isAlreadyOpen = parentLi.classList.contains('is-main-nav-active');

        if (href === '#') {
          e.preventDefault();

          openMenuForLink(e.currentTarget, { moveFocus: true });

          return;
        }

        if (!isAlreadyOpen) {
          e.preventDefault();

          openMenuForLink(e.currentTarget, { moveFocus: true });

          return;
        }
      });
    });

    /**
     * Hover secondo livello:
     * aggiorna sempre il bold/is-submenu-active.
     * Se ha pannello, apre anche il terzo livello.
     * Se non ha pannello, chiude il pannello precedente ma lascia il bold.
     */
    document.addEventListener('mouseover', e => {
      const item = e.target.closest('[data-submenu-item][data-submenu-id]');
      if (!item) return;

      if (!item.closest('.Header__SubmenuList')) return;

      handleSecondLevelItemFocusOrHover(item, {
        openPanel: true,
      });
    });

    /**
     * Focus secondo livello:
     * aggiorna sempre il bold/is-submenu-active,
     * anche per link senza sottovoci.
     * Non apre automaticamente il pannello.
     */
    document.addEventListener('focusin', e => {
      const item = e.target.closest('[data-submenu-item][data-submenu-id]');
      if (!item) return;

      if (!item.closest('.Header__SubmenuList')) return;

      handleSecondLevelItemFocusOrHover(item, {
        openPanel: false,
      });
    });

    /**
     * Click sulle voci di secondo livello con sottomenu:
     * apre il terzo livello ed entra nel pannello.
     * I link senza sottovoci navigano normalmente.
     */
    document.addEventListener('click', e => {
      const link = e.target.closest('[data-submenu-link-id]');
      if (!link) return;

      const ul = link.closest('.Header__SubmenuList');
      if (!ul) return;

      const href = link.getAttribute('href');
      const isExpanded = link.getAttribute('aria-expanded') === 'true';

      if (href === '#') {
        e.preventDefault();

        togglePanelFromLink(link, ul, { moveFocus: true });

        return;
      }

      if (!isExpanded) {
        e.preventDefault();

        togglePanelFromLink(link, ul, { moveFocus: true });

        return;
      }
    });

    document.addEventListener('keydown', e => {
      const link = e.target.closest('[data-submenu-link-id]');
      if (!link) return;

      if (e.key !== 'Enter' && e.key !== ' ') return;

      const ul = link.closest('.Header__SubmenuList');
      if (!ul) return;

      const href = link.getAttribute('href');
      const isExpanded = link.getAttribute('aria-expanded') === 'true';

      if (e.key === ' ') {
        e.preventDefault();

        togglePanelFromLink(link, ul, { moveFocus: true });

        return;
      }

      if (href === '#') {
        e.preventDefault();

        togglePanelFromLink(link, ul, { moveFocus: true });

        return;
      }

      if (!isExpanded) {
        e.preventDefault();

        togglePanelFromLink(link, ul, { moveFocus: true });
      }
    });

    /**
     * Shift + Tab dal primo focusable del pannello:
     * torna alla voce che ha aperto quel pannello.
     */
    document.addEventListener('keydown', e => {
      if (e.key !== 'Tab' || !e.shiftKey) return;

      const activePanel = e.target.closest(
        '.Header__SubmenuPanels [data-submenu-panel].is-active'
      );

      if (!activePanel) return;

      const focusables = getFocusableElements(activePanel);
      const currentIndex = focusables.indexOf(e.target);

      if (currentIndex !== 0) return;

      const activeLink =
        getActiveSubmenuLinkForPanel(activePanel) ||
        lastOpenedSubmenuLink;

      if (!activeLink) return;

      e.preventDefault();
      e.stopPropagation();

      lastShiftTabPanel = activePanel;
      activeLink.focus();
    }, true);

    /**
     * Fallback:
     * se qualche listener del tema/browser riesce comunque a mandare il focus
     * sull'ultimo item del secondo livello, lo riportiamo subito al link corretto.
     */
    document.addEventListener('focusin', e => {
      if (!lastShiftTabPanel) return;

      const activeLink =
        getActiveSubmenuLinkForPanel(lastShiftTabPanel) ||
        lastOpenedSubmenuLink;

      if (!activeLink) {
        lastShiftTabPanel = null;
        return;
      }

      if (e.target === activeLink) {
        lastShiftTabPanel = null;
        return;
      }

      const submenuRoot = lastShiftTabPanel.closest('.Header__MainNav__Submenu');

      if (
        submenuRoot &&
        submenuRoot.contains(e.target) &&
        e.target.closest('.Header__SubmenuList')
      ) {
        e.stopPropagation();

        window.requestAnimationFrame(() => {
          activeLink.focus();
          lastShiftTabPanel = null;
        });
      }
    }, true);

    /**
     * Esc: chiude completamente il popover aperto,
     * da qualsiasi livello ci si trovi, e riporta
     * il focus sul link di primo livello che lo ha aperto.
     */
    document.addEventListener('keydown', e => {
      if (e.key !== 'Escape') return;

      const activeMainItem = document.querySelector(
        '.Header__MainNav .HorizontalList__Item.is-main-nav-active'
      );

      if (!activeMainItem) return;

      const mainLink = activeMainItem.querySelector('.Header__MainNav__Link');

      e.preventDefault();
      e.stopPropagation();

      closeAllMenus();

      mainLink?.focus();
    }, true);

    header?.addEventListener('mouseleave', closeAllMenus);

    return;
  }
});


function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

//Add class 'reveal' on scroll
function reveal() {
  const revealElements = document.querySelectorAll('.Image--toReveal');
  for (var i = 0; i < revealElements.length; i++) {
    const windowHeight = window.innerHeight;
    const elementTop = revealElements[i].getBoundingClientRect().top;
    const elementVisible = 150;

    if (elementTop < windowHeight - elementVisible) {
      revealElements[i].classList.add("reveal");
    }
  }
}

window.addEventListener('scroll', reveal);

//when the image gallery loads, assign set height and width of .Product__SlideItem to .product__zoom-wrapper - desktop
function setZoomWrapperSize() {
var productSlideItem = document.querySelector('.Product__SlideItem');
var productZoomWrapper = document.querySelector('.product__zoom-wrapper');
var productSlideContainer = document.querySelector('.Product__Slideshow');
if(productSlideItem && productZoomWrapper) {
  var productSlideItemWidth = productSlideItem.offsetWidth;
  var productSlideItemHeight = productSlideItem.offsetHeight;
  var productSlideItemMarginRight = window.getComputedStyle(productSlideContainer).marginRight;
  productZoomWrapper.style.width = productSlideItemWidth + 'px';
  productZoomWrapper.style.height = productSlideItemHeight + 'px';
}
}

$('document').ready(function(){
  var productPage = window.location.href.includes('/products');
  if(productPage) {
    setZoomWrapperSize();
  }
});

window.addEventListener('resize', function() {
  setZoomWrapperSize();
});

function generateApiKey() {
  const fixedKey = 'j832e4p9nv3e17b3y75o6b0r1b1be0fvd';
  const currentDate = new Date();
  const day = String(currentDate.getDate()).padStart(2, '0');
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  const year = currentDate.getFullYear();
  const dateString = `${day}/${month}/${year}`;
  const key = `${fixedKey}${dateString}`;
  const base64Key = btoa(key); 
  return base64Key;
}

async function callWebService(email, orderId) {
  const apiUrl = `https://backoffice.ragno.eu/API/GetReturnCode?email=${email}&orderid=${orderId}`; // Replace with your actual URL
  const apiKey = generateApiKey();

  try {
      const response = await fetch(apiUrl, {
          method: 'GET',
          headers: {
              'mode': "no-cors",
              'Content-Type': 'application/json',
              'x-api-key': apiKey
          }
      });

      const result = await response.json();

      if (result.SUCCESS) {
          const data = result.DATA[0]; 
          return data;
      } else {
        console.error('Error Code:', result.ERRORCODE);
        console.error('Error Message:', result.ERRORMESSAGE);
        return result;
      }
  } catch (error) {
      console.error('Fetch Error:', error);
      return error;
  }
}

$('document').ready(function () {
  const isReturnsFormPage = window.location.href.includes('form-resi');
  const form = document.querySelector('#returns_form');

  if (isReturnsFormPage && form) {
    const backButton = document.querySelector('.Returns_Form_back_button');
    const shippyproForm = document.querySelector('#returnDiv');
    const orderNumber = form.querySelector('#order_number');
    const email = form.querySelector('#customer_email');
    const intro = document.querySelector('.FormResi__BlockContent');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const emailValue = email.value;
      const orderNumberValue = orderNumber.value;

      //if the email and order number are not provided, show an error message
      if (email == '' || orderNumber == '') {
        document.querySelector('.js-error').style.display = 'block';
        return;
      }

      callWebService(emailValue, orderNumberValue).then(data => {
        const ragnoOrderNumber = data;
        if(data.SUCCESS == false){
          const error = data.ERRORCODE;
          let errorMessage = '';
          if(error == -30){
            errorMessage = window.languages.returnFormOrderNotFound;
          }
          else if(error == -40){
            errorMessage = window.languages.returnAlreadyRequested;
          }
          else if(error == -500){
            errorMessage = window.languages.returnFormInternalError;
          }
          else {
            errorMessage = data.ERRORMESSAGE;
          }
          document.querySelector('.js-error').textContent = errorMessage;
          document.querySelector('.js-error').style.display = 'block';
          return;
        }
        var returnFormId = '6055';
        var language = document.documentElement.lang;

        var preInputTrackingNumber = `${ragnoOrderNumber}`;
        var preInputLanguage = `${language}`;
        var script = document.createElement('script');
        script.innerHTML = `
            var returnFormId = '${returnFormId}';
            var preInputTrackingNumber = '${preInputTrackingNumber}';
            var preInputLanguage = '${preInputLanguage}';
            (function(e,t,n){
                var r,i=e.getElementsByTagName(t)[0];
                if(e.getElementById(n)) return;
                r=e.createElement(t);r.id=n;r.src="https://www.shippypro.com/return-form.js";
                i.parentNode.insertBefore(r,i)
            })(document,"script","shippypro-returnform-sdk");
        `;
        shippyproForm.appendChild(script);
        backButton.style.display = 'block';
        form.style.display = 'none';
        intro.style.display = 'none';
        setTimeout(() => {
          ShippyProReturnForm.loadTracking();
        }, "1000");
      });

    });

    backButton.addEventListener('click', function () {
      location.reload();
    });
  }
});
function waitForElm(selector) {
  return new Promise(resolve => {
      if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver(mutations => {
          if (document.querySelector(selector)) {
              observer.disconnect();
              resolve(document.querySelector(selector));
          }
      });

      observer.observe(document.body, {
          childList: true,
          subtree: true
      });
  });
}

// Doofinder search, handle show/hide for the sublevel menu

const doofinderSearch = document.querySelector('.dfd-close-button');
const toggleSearch = document.querySelector('[data-action="toggle-search"]');
toggleSearch.addEventListener('click', function() {
  const last_clicked_menu = JSON.parse(localStorage.getItem('clicked_menu'));
  waitForElm('.dfd-close-button').then((elm) => {
    elm.addEventListener('click', function() {
        document.querySelector(`.Header__MainNav__Submenu.${last_clicked_menu}`).setAttribute('aria-hidden', 'false');
    })
  });
});


document.addEventListener('DOMContentLoaded', function () {
  // Function to handle the visibility of fields based on the selected value
  function handleFieldVisibility(formSelector, fieldSelector, visibilityMap) {
    const form = document.querySelector(formSelector);
    if (!form) return;

    // Disabilita tutti i campi nascosti al caricamento della pagina
    Object.values(visibilityMap).forEach(({ selector }) => {
      const element = form.querySelector(selector);
      if (element) {
        setFieldsDisabled(element, true);
      }
    });

    const field = form.querySelector(fieldSelector);
    field.addEventListener('change', function (e) {
      const selectedValue = e.target.value;

      Object.keys(visibilityMap).forEach(key => {
        const { selector, values } = visibilityMap[key];
        const element = form.querySelector(selector);
        const isVisible = values.includes(selectedValue);

        element.style.display = isVisible ? 'block' : 'none';
        setFieldsDisabled(element, !isVisible);

        if (isVisible) {
          // Pulisce il valore quando il campo diventa visibile
          const inputElement = element.querySelector('input');
          const selectElement = element.querySelector('select');
          if (inputElement) inputElement.value = '';
          if (selectElement) selectElement.selectedIndex = 0;
        }
      });
    });
  }

  // Abilita o disabilita tutti gli input/select/textarea dentro un elemento
  function setFieldsDisabled(element, disabled) {
    element.querySelectorAll('input, select, textarea').forEach(el => {
      el.disabled = disabled;
    });
  }

  const contactFormVisibilityMap = {
    storeName: {
      selector: '#store_name',
      values: ['negozio']
    },
    retailerName: {
      selector: '#retailer_name',
      values: ['rivenditore']
    }
  };

  // Initialize the field visibility handler for the contact form
  handleFieldVisibility('#contact_form', '#purchase_method', contactFormVisibilityMap);
});

// Accessibilità
document.addEventListener('DOMContentLoaded', function() {

  /* Focus video show controls */
  const videos = document.querySelectorAll('.slideshow__video');
  if (!videos || videos.length === 0) return;
  videos.forEach(video => {
    if (!(video instanceof HTMLVideoElement)) return;
    if (!video.hasAttribute('tabindex')) {
      video.setAttribute('tabindex', '0');
    }
    const showControls = () => video.setAttribute('controls', 'controls');
    const hideControls = () => {
      if (!video.paused) video.removeAttribute('controls');
    };
    video.addEventListener('focus', showControls);
    video.addEventListener('blur', hideControls);
  });

  /* Rimosso tabindex allo slider */
  if (document.querySelector('.Product__Slideshow')) {
    document.querySelector('.Product__Slideshow').setAttribute('tabindex', '-1');
  }
  if (document.querySelector(".Carousel.CollectionList--spaced")) {
    document.querySelector('.Carousel.CollectionList--spaced').setAttribute('tabindex', '-1');
  }

  /* Zoom immagini prodotti accessibili */
  // Oggetto per tracciare lo zoom di ogni immagine
  const zoomLevels = {};
  const minZoom = 1;
  const maxZoom = 3;
  const zoomStep = 0.1;

  // Inizializza zoom levels
  document.querySelectorAll('.zoom-target').forEach(img => {
    const mediaId = img.getAttribute('data-media-id');
    if (mediaId) {
      zoomLevels[mediaId] = 1; // zoom iniziale 1x
    }
  });

  // Gestione pulsanti zoom
  document.querySelectorAll('.zoom-btn').forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const controls = this.closest('.zoom-controls');
      const mediaId = controls.getAttribute('data-media-id');
      const img = document.querySelector(`[data-media-id="${mediaId}"].zoom-target`);
      const action = this.getAttribute('data-action');
      
      if (img && mediaId) {
        let currentZoom = zoomLevels[mediaId] || 1;
        
        if (action === 'zoom-in') {
          currentZoom = Math.min(currentZoom + zoomStep, maxZoom);
        } else if (action === 'zoom-out') {
          currentZoom = Math.max(currentZoom - zoomStep, minZoom);
        }
        
        // Aggiorna zoom
        zoomLevels[mediaId] = currentZoom;
        img.style.transform = `scale(${currentZoom})`;
        
        // Disabilita pulsanti ai limiti
        updateButtonStates(controls, currentZoom);
      }
    });

    // Gestione tastiera (Enter e Spazio)
    btn.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.click();
      }
    });
  });

  // Funzione per aggiornare stato pulsanti
  function updateButtonStates(controls, zoom) {
    const zoomInBtn = controls.querySelector('.zoom-in');
    const zoomOutBtn = controls.querySelector('.zoom-out');
    
    // Disabilita zoom-in se al massimo
    if (zoom >= maxZoom) {
      zoomInBtn.style.opacity = '0.5';
      zoomInBtn.style.pointerEvents = 'none';
    } else {
      zoomInBtn.style.opacity = '1';
      zoomInBtn.style.pointerEvents = 'auto';
    }
    
    // Disabilita zoom-out se al minimo
    if (zoom <= minZoom) {
      zoomOutBtn.style.opacity = '0.5';
      zoomOutBtn.style.pointerEvents = 'none';
    } else {
      zoomOutBtn.style.opacity = '1';
      zoomOutBtn.style.pointerEvents = 'auto';
    }
  }

  // Reset zoom quando si perde focus sulla slide
  document.querySelectorAll('.Product__SlideItem').forEach(slide => {
    slide.addEventListener('blur', function() {
      const img = this.querySelector('.zoom-target');
      const controls = this.querySelector('.zoom-controls');
      
      if (img && controls) {
        const mediaId = img.getAttribute('data-media-id');
        if (mediaId) {
          zoomLevels[mediaId] = 1;
          img.style.transform = 'scale(1)';
          updateButtonStates(controls, 1);
        }
      }
    });
  });

  // Inizializza stato pulsanti
  document.querySelectorAll('.zoom-controls').forEach(controls => {
    updateButtonStates(controls, 1);
  });
});


/* Carousel video block */
document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector(".videoSwiper")) {
    // --- swiper principale delle card ---
    const carousel = new Swiper(".videoSwiper", {
      slidesPerView: 1.5,
      spaceBetween: 16,
      navigation: { nextEl: ".button-next", prevEl: ".button-prev" },
       autoplay: {
        delay: 8000,
        disableOnInteraction: true
      },
      loop: true,
      centeredSlides: true,
      breakpoints: { 768: { slidesPerView: 3, spaceBetween: 16 } }
    });

    const getAllThumbVideos = () => Array.from(document.querySelectorAll(".video-thumbnail video"));
    const pauseAllThumbs = (reset=false) => getAllThumbVideos().forEach(v=>{ try{v.pause();}catch{} if(reset){try{v.currentTime=0;}catch{}}});
    const playActiveThumb = () => {
      const activeSlide = carousel.slides[carousel.activeIndex];
      if (!activeSlide) return;
      const v = activeSlide.querySelector(".video-thumbnail video");
      if (!v) return;
      v.muted = true; v.play().catch(()=>{});
    };
    pauseAllThumbs(true); playActiveThumb();
    carousel.on("slideChangeTransitionStart", pauseAllThumbs);
    carousel.on("slideChangeTransitionEnd", playActiveThumb);
    document.addEventListener("visibilitychange", ()=>{ document.hidden ? pauseAllThumbs() : playActiveThumb(); });

    function setSlideA11y() {
      // consenti focus SOLO allo slide attivo (opzione più “chiara” per la tastiera)
      const ALLOW = (slide) => slide.classList.contains("swiper-slide-active");
      carousel.slides.forEach(slide => {
        const isAllowed = ALLOW(slide);
        const thumb = slide.querySelector(".video-thumbnail");
        const vid   = slide.querySelector("video");

        if (isAllowed) {
          slide.removeAttribute("inert");
          if (thumb) thumb.tabIndex = 0;   // focus solo sul thumbnail attivo
        } else {
          slide.setAttribute("inert","");  // blocca TUTTI i discendenti dal focus
          if (thumb) thumb.tabIndex = -1;
        }
        if (thumb) {
          thumb.setAttribute("role", "button");
          thumb.setAttribute("aria-haspopup", "dialog");
        }
        // in ogni caso evitiamo che <video> entri nel tab order
        if (vid) vid.tabIndex = -1;
      });
    }

    // inizializza subito
    setSlideA11y();

    // riallinea quando cambia lo stato dello slider
    carousel.on("slideChangeTransitionEnd", setSlideA11y);
    carousel.on("loopFix", setSlideA11y);
    carousel.on("resize", setSlideA11y);

    // --- riferimenti modale ---
    const modal       = document.getElementById("videoModal");
    const closeBtn    = modal.querySelector(".close-modal");
    const playBtn     = document.querySelector(".video-center-play");
    const muteBtn     = document.querySelector(".video-mute");
    const modalSwiperWrapper = modal.querySelector(".modalSwiper .swiper-wrapper");

    // --- prodotti (markup mobile nuovo) ---
    const videoProducts     = modal.querySelector(".video-products");                  // <aside>
    const productsContainer = videoProducts?.querySelector(".videoProductsContainer"); // wrapper lista + titolo
    const productsBox       = videoProducts?.querySelector(".products-list");         // griglia prodotti
    const mobileFeatures    = videoProducts?.querySelector(".mobileFeatures");        // bottoni bassi
    const openProductsBtn   = videoProducts?.querySelector(".openModalProducts");     // "Acquista prodotti"
    const chevronBtn        = videoProducts?.querySelector(".closeProdcutsPreview");  // chevron toggle preview
    const topCloseBtn       = videoProducts?.querySelector(".topContentMobileModal button"); // chiudi fullscreen

    const normalizeSrc = (src) => src?.startsWith("//") ? (location.protocol + src) : src;
    const isMobile = () => window.matchMedia("(max-width: 47.999rem)").matches;

    let lastFocused = null;
    let userWantsMuted = false;
    let currentIndex = 0;
    let activeVideoEl = null;
    let isSyncing = false;
    let wasPlayingBeforeProductsFs = false;

    // --- playlist dal grid esterno ---
    const tiles = Array.from(document.querySelectorAll(".video-thumbnail"));
    const playlist = tiles.map(t => {
      let products = [];
      const jsonEl = t.querySelector(".products-json");
      if (jsonEl) { try { products = JSON.parse(jsonEl.textContent.trim() || "[]"); } catch{} }
      const poster = t.querySelector("video")?.getAttribute("poster") || t.querySelector("img")?.src || "";
      return { src: normalizeSrc(t.dataset.videoSrc || ""), type: t.dataset.videoType || "", products, poster };
    });

    // ----- thumbs nella modale -----
    const thumbsWrapper = document.createElement("aside");
    thumbsWrapper.className = "modal-thumbs";
    thumbsWrapper.innerHTML = `
      <button class="thumbs-prev" aria-label="Video precedente"><svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.11089 10.4443L9.99978 1.55545L18.8887 10.4443" stroke="white" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"></path></svg></button>
      <div class="swiper thumbsSwiper"><div class="swiper-wrapper"></div></div>
      <button class="thumbs-next" aria-label="Video successivo"><svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.11089 1.55567L9.99978 10.4446L18.8887 1.55566" stroke="white" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"></path></svg></button>
    `;
    modal.querySelector(".video-content").insertBefore(thumbsWrapper, modal.querySelector(".video-player"));

    const thumbsContainer = thumbsWrapper.querySelector(".thumbsSwiper .swiper-wrapper");
    playlist.forEach((item,i)=>{
      const s = document.createElement("div");
      s.className="swiper-slide"; s.dataset.idx=String(i);
      s.innerHTML = `<div class="thumb-card"><img src="${item.poster||""}" alt="Anteprima video ${i+1}"></div>`;
      thumbsContainer.appendChild(s);
    });

    // ----- slide video al centro della modale -----
    playlist.forEach((item,i)=>{
      const s = document.createElement("div");
      s.className = "swiper-slide";
      s.innerHTML = `<video class="modal-video" data-idx="${i}" playsinline webkit-playsinline preload="metadata" src="${item.src}"></video>`;
      modalSwiperWrapper.appendChild(s);
    });

    const thumbsSwiper = new Swiper(thumbsWrapper.querySelector(".thumbsSwiper"), {
      slidesPerView: 1,
      centeredSlides: true,
      loop: true,
      spaceBetween: 16,
      navigation: { nextEl: thumbsWrapper.querySelector(".thumbs-next"), prevEl: thumbsWrapper.querySelector(".thumbs-prev") },
      breakpoints: { 768: { direction: "vertical", slidesPerView: 3, spaceBetween: 16 } }
    });

    const modalSwiper = new Swiper(".modalSwiper", {
      direction: "vertical",
      slidesPerView: 1,
      centeredSlides: true,
      loop: true,
      spaceBetween: 0
    });

    // --- helpers video attivo ---
    const detachActiveVideo = () => {
      if (!activeVideoEl) return;
      try { activeVideoEl.pause(); } catch {}
      if (activeVideoEl._cleanup) activeVideoEl._cleanup();
      activeVideoEl = null;
    };

    const wireVideoUi = (v) => {
      const onPlay = () => playBtn.classList.add("is-pause");
      const onPause = () => playBtn.classList.remove("is-pause");
      const onVol = () => muteBtn.setAttribute("aria-pressed", v.muted ? "true":"false");
      const onEnded = () => { if (!isSyncing) modalSwiper.slideNext(300); };

      v.addEventListener("play", onPlay);
      v.addEventListener("playing", onPlay);
      v.addEventListener("pause", onPause);
      v.addEventListener("ended", onEnded);
      v.addEventListener("volumechange", onVol);
      v._cleanup = () => {
        v.removeEventListener("play", onPlay);
        v.removeEventListener("playing", onPlay);
        v.removeEventListener("pause", onPause);
        v.removeEventListener("ended", onEnded);
        v.removeEventListener("volumechange", onVol);
      };
    };

    const setActiveVideo = async () => {
      const slide = modal.querySelector(".modalSwiper .swiper-slide.swiper-slide-active");
      const v = slide ? slide.querySelector("video.modal-video") : null;
      if (!v) return;
      detachActiveVideo();
      activeVideoEl = v;
      wireVideoUi(activeVideoEl);
      activeVideoEl.muted = userWantsMuted;
      try { await activeVideoEl.play(); }
      catch {
        // se non parte con audio, forzo muted e riprovo
        if (!userWantsMuted) {
          userWantsMuted = true;
          activeVideoEl.muted = true;
          muteBtn.setAttribute("aria-pressed", "true");
          try { await activeVideoEl.play(); } catch {}
        }
      }
    };

    // --- render prodotti ---
    const renderProducts = (idx) => {
      if (!productsBox) return;
      productsBox.innerHTML = "";
      const item = playlist[idx]; if (!item) return;
      const truncate = (s,n=18)=> (typeof s==="string" && s.length>n) ? (s.slice(0,n-1)+"…") : s;
      item.products.forEach(p=>{
        const card = document.createElement("div");
        card.className="product"; card.setAttribute("role","link"); card.tabIndex=0;
        card.addEventListener("click", (e)=>{ e.stopPropagation(); window.location.href=p.url; });
        card.addEventListener("keypress",(e)=>{ if(e.key==="Enter"||e.key===" "){ e.preventDefault(); e.stopPropagation(); window.location.href=p.url; }});
        card.innerHTML = `
          <img src="${p.image}" alt="${p.title}">
          <div class="container_product_modal">
            <p class="product-title">${truncate(p.title,20)}</p>
            <p class="product-price">${p.price}</p>
            <a href="${p.url}" class="btn">Acquista ora</a>
          </div>
        `;
        productsBox.appendChild(card);
      });
    };

    const syncUiForIndex = (idx) => {
      currentIndex = (idx + playlist.length) % playlist.length;
      isSyncing = true;
      thumbsSwiper.slideToLoop(currentIndex, 0);
      isSyncing = false;
      renderProducts(currentIndex);
    };

    // --- animazione ingresso video-products su mobile ---
    const animateProductsEntrance = () => {
      if (!videoProducts || !isMobile()) return;
      videoProducts.classList.remove("anim-enter","anim-enter-active");
      void videoProducts.offsetWidth; // reflow per riavvio
      videoProducts.classList.add("anim-enter");
      requestAnimationFrame(()=> videoProducts.classList.add("anim-enter-active"));
      setTimeout(()=>videoProducts.classList.remove("anim-enter","anim-enter-active"), 500);
    };

    // --- stati aside (collapsed/preview/fullscreen) ---
    const setProductsState = (state) => {
      if (!videoProducts) return;
      videoProducts.dataset.state = state;
      videoProducts.classList.remove("is-collapsed","is-preview","is-fullscreen");
      if (state === "collapsed") {
        videoProducts.classList.add("is-collapsed");
        productsContainer?.classList.add("is-hidden");
        productsContainer?.classList.remove("is-fullscreen");
        mobileFeatures?.classList.remove("is-hidden");
        document.body.classList.remove("video-products-fullscreen-open");
      } else if (state === "preview") {
        videoProducts.classList.add("is-preview");
        productsContainer?.classList.remove("is-hidden");
        productsContainer?.classList.remove("is-fullscreen");
        mobileFeatures?.classList.remove("is-hidden");
        animateProductsEntrance();
        document.body.classList.remove("video-products-fullscreen-open");
      } else if (state === "fullscreen") {
        videoProducts.classList.add("is-fullscreen");
        productsContainer?.classList.remove("is-hidden");
        productsContainer?.classList.add("is-fullscreen");
        mobileFeatures?.classList.add("is-hidden");
        document.body.classList.add("video-products-fullscreen-open");
      }
    };

    // --- sincronizzazioni tra swiper ---
    modalSwiper.on("slideChangeTransitionStart", () => {
      detachActiveVideo();
    });
    modalSwiper.on("slideChangeTransitionEnd", async () => {
      const idx = modalSwiper.realIndex;
      syncUiForIndex(idx);
      await setActiveVideo();

      // ogni cambio slide: entrata da sotto e stato preview
      if (isMobile()) setProductsState("preview");
    });

    thumbsSwiper.on("slideChangeTransitionEnd", () => {
      if (isSyncing) return;
      const idx = thumbsSwiper.realIndex;
      if (idx !== modalSwiper.realIndex) {
        isSyncing = true;
        modalSwiper.slideToLoop(idx, 300);
        isSyncing = false;
      }
    });

    thumbsWrapper.querySelector(".thumbsSwiper").addEventListener("click",(e)=>{
      const slide = e.target.closest(".swiper-slide"); if(!slide) return;
      const idx = parseInt(slide.dataset.idx,10);
      isSyncing = true;
      modalSwiper.slideToLoop(idx, 300);
      isSyncing = false;
    });

    // --- apertura/chiusura modale video ---
    const openModal = ({ src }) => {
      pauseAllThumbs(true); // stoppa i video sotto
      lastFocused = document.activeElement;
      document.body.classList.add("modal-open");
      modal.classList.remove("hidden");

      // audio non forzato: lasciamo userWantsMuted = false (ripristino)
      muteBtn.setAttribute("aria-pressed", userWantsMuted ? "true" : "false");
      playBtn.classList.remove("is-pause");

      const startIdx = Math.max(0, playlist.findIndex(p => p.src === normalizeSrc(src)));
      isSyncing = true;
      modalSwiper.slideToLoop(startIdx, 0);
      thumbsSwiper.slideToLoop(startIdx, 0);
      isSyncing = false;
      syncUiForIndex(startIdx);
      setActiveVideo();

      // su mobile: parte in preview e arriva da sotto
      if (isMobile()) setProductsState("preview");

      closeBtn.focus();
      trapFocus(modal);
    };

    const closeModal = () => {
      modal.classList.add("hidden");
      document.body.classList.remove("modal-open","video-products-fullscreen-open");
      releaseFocus();
      detachActiveVideo();
      if (lastFocused && typeof lastFocused.focus === "function") lastFocused.focus();
      playActiveThumb();
      if (isMobile()) setProductsState("collapsed");
    };

    // attiva dalla griglia principale
    document.addEventListener("click", (e) => {
      const thumb = e.target.closest(".video-thumbnail"); if (!thumb) return;
      const src  = thumb.dataset.videoSrc; if (src) openModal({ src });
    });

    document.addEventListener("keydown", (e) => {
      const isEnter = e.key === "Enter";
      const isSpace = e.key === " " || e.key === "Spacebar";
      if (!isEnter && !isSpace) return;

      const thumb = e.target.closest(".video-thumbnail");
      if (!thumb) return;

      const slide = thumb.closest(".swiper-slide");
      if (!slide || !slide.classList.contains("swiper-slide-active")) return;

      e.preventDefault(); // evita scroll con Space
      const src = thumb.dataset.videoSrc;
      if (src) openModal({ src });
    });

    // controlli play/mute
    playBtn.addEventListener("click", async (e)=>{
      e.stopPropagation();
      if (!activeVideoEl) return;
      if (activeVideoEl.paused) { await activeVideoEl.play().catch(()=>{}); }
      else { try{ activeVideoEl.pause(); }catch{} }
    });
    modal.addEventListener("click",(e)=>{
      if (!e.target.closest(".modalSwiper")) return;
      if (!activeVideoEl) return;
      activeVideoEl.paused ? activeVideoEl.play().catch(()=>{}) : activeVideoEl.pause();
    });
    muteBtn.addEventListener("click", (e)=>{
      e.stopPropagation();
      userWantsMuted = !userWantsMuted;
      if (activeVideoEl) activeVideoEl.muted = userWantsMuted;
      muteBtn.setAttribute("aria-pressed", userWantsMuted ? "true":"false");
    });
    closeBtn.addEventListener("click", closeModal);

    // --- focus trap
    function trapFocus(container){
      const focusable = container.querySelectorAll('a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])');
      const items = Array.from(focusable).filter(el=>!el.hasAttribute("disabled"));
      if (!items.length) return;
      function onKey(e){
        // ESC: se fullscreen prodotti -> torna a preview, altrimenti chiude modale video
        if (e.key==="Escape"){
          const state = videoProducts?.dataset.state;
          if (isMobile() && state === "fullscreen") {
            e.preventDefault(); setProductsState("preview");
            // riprendi il video se era in play
            if (wasPlayingBeforeProductsFs && activeVideoEl?.paused) { activeVideoEl.play().catch(()=>{}); }
            document.body.classList.remove("video-products-fullscreen-open");
            return;
          }
          e.preventDefault(); closeModal(); return;
        }
        if (e.key!=="Tab") return;
        const first=items[0], last=items[items.length-1];
        if (e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
      }
      container.dataset._trap="1"; container.addEventListener("keydown", onKey); container._trapHandler=onKey;
    }
    function releaseFocus(){
      if (!modal.dataset._trap) return;
      modal.removeEventListener("keydown", modal._trapHandler);
      delete modal.dataset._trap; delete modal._trapHandler;
    }

    // --- interazioni mobile prodotti ---
    // chevron: toggle preview <-> collapsed (lista sotto il video)
    chevronBtn?.addEventListener("click", (e) => {
      e.preventDefault(); e.stopPropagation();
      const state = videoProducts?.dataset.state;
      if (state === "preview") setProductsState("collapsed");
      else if (state === "collapsed") setProductsState("preview");
      // se si era in fullscreen, ignoro (chevron non visibile lì in genere)
    });

    // apri modale prodotti fullscreen (2 colonne) -> pausa audio/video
    openProductsBtn?.addEventListener("click", (e) => {
      e.preventDefault(); e.stopPropagation();
      if (activeVideoEl) {
        wasPlayingBeforeProductsFs = !activeVideoEl.paused;
        try { activeVideoEl.pause(); } catch {}
      }
      setProductsState("fullscreen");
    });

    // chiudi modale prodotti fullscreen (freccia in alto) -> riprendi video se era in play
    topCloseBtn?.addEventListener("click", (e) => {
      e.preventDefault(); e.stopPropagation();
      setProductsState("preview");
      if (wasPlayingBeforeProductsFs && activeVideoEl?.paused) {
        activeVideoEl.play().catch(()=>{});
      }
    });
  }
});

/* Accordion mobile */
if (window.innerWidth < 768) {
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-accordion-trigger]');
    if (trigger) {
      const content = trigger.parentElement.querySelector('[data-accordion-content]');
      trigger.classList.toggle('is-active');
      content.classList.toggle('is-open');
    }
  });
}

/* Apertura menu mobile (sidebar-menu) */
(function () {
  const ROOT = "[data-layered-menu]";
  const PANEL = "[data-lm-panel]";
  const OPEN = "[data-lm-open]";
  const BACK = "[data-lm-back]";

  const CLS_ACTIVE = "is-active";
  const CLS_PUSHING = "is-pushing";
  const CLS_POPPING = "is-popping";

  const TRANSITION_MS = 360;

  const esc = (v) => (window.CSS && CSS.escape ? CSS.escape(v) : v);

  function setHidden(panel, hidden) {
    panel.setAttribute("aria-hidden", hidden ? "true" : "false");
    panel.toggleAttribute("inert", hidden);
  }

  function focusFirst(panel) {
    const el = panel.querySelector('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (el) el.focus({ preventScroll: true });
  }

  function init(root) {
    const panels = new Map();
    root.querySelectorAll(PANEL).forEach((p) => {
      panels.set(p.getAttribute("data-lm-panel"), p);
    });

    const rootPanel = panels.get("root");
    if (!rootPanel) return;

    // init
    panels.forEach((p, id) => {
      const isRoot = id === "root";
      p.classList.toggle(CLS_ACTIVE, isRoot);
      p.classList.remove(CLS_PUSHING, CLS_POPPING);
      setHidden(p, !isRoot);
    });

    let stack = ["root"];
    let animating = false;

    function openPanel(opener, id) {
      if (animating) return;
      const next = panels.get(id);
      const current = panels.get(stack[stack.length - 1]);
      if (!next || !current || next === current) return;

      animating = true;

      opener?.setAttribute("aria-expanded", "true");

      setHidden(next, false);
      next.classList.add(CLS_ACTIVE, CLS_PUSHING);

      // reflow
      next.offsetHeight;

      requestAnimationFrame(() => {
        next.classList.remove(CLS_PUSHING);
      });

      stack.push(id);

      window.setTimeout(() => {
        focusFirst(next);
        animating = false;
      }, TRANSITION_MS);
    }

    function goBack() {
      if (animating) return;
      if (stack.length <= 1) return;

      animating = true;

      const leavingId = stack.pop();
      const leaving = panels.get(leavingId);
      const current = panels.get(stack[stack.length - 1]);
      if (!leaving || !current) {
        animating = false;
        return;
      }

      leaving.classList.add(CLS_POPPING);

      const opener = root.querySelector(`${OPEN}[data-lm-open="${esc(leavingId)}"]`);
      opener?.setAttribute("aria-expanded", "false");

      window.setTimeout(() => {
        leaving.classList.remove(CLS_ACTIVE, CLS_POPPING);
        setHidden(leaving, true);
        focusFirst(current);
        animating = false;
      }, TRANSITION_MS);
    }

    root.addEventListener("click", (e) => {
      const opener = e.target.closest(OPEN);
      if (opener && root.contains(opener)) {
        e.preventDefault();
        openPanel(opener, opener.getAttribute("data-lm-open"));
        return;
      }

      const back = e.target.closest(BACK);
      if (back && root.contains(back)) {
        e.preventDefault();
        goBack();
      }
    });

    root.addEventListener("keydown", (e) => {
      if (e.key === "Escape") goBack();
    });
  }

  function boot() {
    document.querySelectorAll(ROOT).forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();

// Script per estrarre e riposizionare il contenuto solo su mobile
(function() {
  // Funzione per verificare se siamo su mobile
  function isMobile() {
    return window.innerWidth <= 768;
  }

  function processMobileExtractSections() {
    const sections = document.querySelectorAll('.js-mobile-extract');

    sections.forEach(section => {
      // Trova il contenitore FlexboxIeFix
      const flexboxContainer = section.querySelector('.FlexboxIeFix');
      if (!flexboxContainer) return;

      const originalBlock   = section.querySelector('.ImageHero__Block');
      const titleBlock      = section.querySelector('.ImageHero__Block > h1, .ImageHero__Block > h2, .ImageHero__Block > h3');
      const contentBlock    = section.querySelector('.ImageHero__BlockContent.Rte');
      const ctaBlock        = section.querySelector('.ImageHero__BlockLink, .ImageHero__Block .Button');

      if (!titleBlock && !contentBlock) return;

      const existingClone = section.querySelector('.mobile-content-clone');

      if (isMobile()) {
        if (!existingClone) {
          const wrapper = document.createElement('div');
          wrapper.classList.add('mobile-content-clone');

          // Copia le classi font dal blocco originale (font-graphik / font-playfair)
          if (originalBlock) {
            if (originalBlock.classList.contains('font-graphik'))  wrapper.classList.add('font-graphik');
            if (originalBlock.classList.contains('font-playfair')) wrapper.classList.add('font-playfair');
          }

          if (titleBlock) {
            const clonedTitle = titleBlock.cloneNode(true);
            clonedTitle.classList.add('mobile-title-clone');
            wrapper.appendChild(clonedTitle);
          }

          if (contentBlock) {
            const clonedContent = contentBlock.cloneNode(true);
            clonedContent.classList.add('mobile-text-clone');
            wrapper.appendChild(clonedContent);
          }

          if (ctaBlock) {
            const clonedCta = ctaBlock.cloneNode(true);
            clonedCta.classList.add('mobile-cta-clone');
            wrapper.appendChild(clonedCta);
          }

          flexboxContainer.insertAdjacentElement('afterend', wrapper);
        }
      } else {
        if (existingClone) existingClone.remove();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processMobileExtractSections);
  } else {
    processMobileExtractSections();
  }

  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(processMobileExtractSections, 250);
  });
})();

// Shop the Look Section
(function() {
  'use strict';

  function initShopTheLook() {
    // Check if section exists
    const section = document.querySelector('[data-shop-look-section]');
    if (!section) return;

    const imageSlides = Array.from(section.querySelectorAll('[data-look-image-slide]'));
    const panes = Array.from(section.querySelectorAll('[data-look-pane]'));
    const prevBtn = section.querySelector('[data-look-prev]');
    const nextBtn = section.querySelector('[data-look-next]');

    if (!imageSlides.length || !panes.length) return;

    const mod = (n, m) => ((n % m) + m) % m;
    let activeLook = 0;

    function setActiveLook(index) {
      const total = panes.length;
      activeLook = mod(index, total);

      imageSlides.forEach(el => {
        el.classList.toggle('is-active', Number(el.dataset.lookImageSlide) === activeLook);
      });

      panes.forEach(el => {
        el.classList.toggle('is-active', Number(el.dataset.lookPane) === activeLook);
      });

      const pane = panes[activeLook];
      if (pane) {
        const track = pane.querySelector('[data-products-track]');
        if (track) {
          // Cambiato behavior in 'smooth' per evitare il salto brusco a sinistra
          track.scrollTo({ left: 0, behavior: 'smooth' });
        }
      }
    }

    // Arrow navigation
    if (prevBtn) {
      prevBtn.addEventListener('click', () => setActiveLook(activeLook - 1));
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => setActiveLook(activeLook + 1));
    }

    // Funzione per gestire lo scroll (Drag su Desktop, Nativo su Mobile)
    function enableDragScroll(track) {
      let isDown = false;
      let startX = 0;
      let scrollLeft = 0;
      let moved = 0;
      let velocity = 0;
      let momentumID;

      function beginMomentumTracking() {
        cancelMomentumTracking();
        momentumID = requestAnimationFrame(momentumLoop);
      }

      function cancelMomentumTracking() {
        if (momentumID) cancelAnimationFrame(momentumID);
      }

      function momentumLoop() {
        track.scrollLeft += velocity;
        // FRIZIONE: 0.97 rende lo scroll molto più fluido e duraturo rispetto a 0.95
        velocity *= 0.97; 
        if (Math.abs(velocity) > 0.5) {
          momentumID = requestAnimationFrame(momentumLoop);
        }
      }

      track.addEventListener('pointerdown', (e) => {
        // Su mobile lasciamo lo scroll nativo del browser
        if (e.pointerType === 'touch') return; 

        if (e.button !== undefined && e.button !== 0) return;
        if (e.target.closest('a, button')) return;

        isDown = true;
        moved = 0;
        velocity = 0;

        track.style.cursor = 'grabbing';
        track.style.scrollSnapType = 'none';
        track.style.scrollBehavior = 'auto'; // Fondamentale per la reattività del drag

        startX = e.pageX - track.offsetLeft;
        scrollLeft = track.scrollLeft;

        cancelMomentumTracking();
        track.setPointerCapture(e.pointerId);
      });

      track.addEventListener('pointermove', (e) => {
        if (!isDown || e.pointerType === 'touch') return;
        
        const x = e.pageX - track.offsetLeft;
        // Moltiplicatore 1.5 per rendere il trascinamento meno "pesante"
        const walk = (x - startX) * 1.5; 
        const prevScrollLeft = track.scrollLeft;
        
        track.scrollLeft = scrollLeft - walk;
        velocity = track.scrollLeft - prevScrollLeft;
        moved = Math.max(moved, Math.abs(walk));
      });

      const end = (e) => {
        if (!isDown || e.pointerType === 'touch') return;
        
        isDown = false;
        track.style.cursor = 'grab';
        
        try { track.releasePointerCapture(e.pointerId); } catch (_) {}
        
        if (Math.abs(velocity) > 0.5) {
          beginMomentumTracking();
        }
        
        // Riattiva lo snap e il behavior smooth dopo un brevissimo delay
        setTimeout(() => {
          track.style.scrollSnapType = 'x mandatory';
          track.style.scrollBehavior = 'smooth';
        }, 50);
        
        if (moved > 8) {
          const stopClick = (evt) => {
            evt.stopPropagation();
            evt.preventDefault();
            track.removeEventListener('click', stopClick, true);
          };
          track.addEventListener('click', stopClick, true);
          setTimeout(() => track.removeEventListener('click', stopClick, true), 300);
        }
      };

      track.addEventListener('pointerup', end);
      track.addEventListener('pointercancel', end);
      track.addEventListener('pointerleave', end);
      track.style.cursor = 'grab';
    }

    // Initialize each pane
    function initPane(pane) {
      const track = pane.querySelector('[data-products-track]');
      if (!track) return;
      enableDragScroll(track);
    }

    panes.forEach(initPane);

    // Initialize first look
    setActiveLook(0);
  }

  // Init when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShopTheLook);
  } else {
    initShopTheLook();
  }

})();

// Collega dinamicamente aria-controls del bottone di ricerca al wrapper Doofinder
(function () {
  if (window.__searchAriaControlsInit) return;
  window.__searchAriaControlsInit = true;

  document.addEventListener('DOMContentLoaded', function () {
    var searchButton = document.querySelector('[data-action="toggle-search"]');
    if (!searchButton) return;

    function linkWrapper(el) {
      if (el && el.id) {
        searchButton.setAttribute('aria-controls', el.id);
        return true;
      }
      return false;
    }

    // Caso 1: il wrapper esiste già nel DOM al caricamento (anche se hidden)
    var existing = document.querySelector('.dfd-root[data-dfd-view="Search"]');
    if (linkWrapper(existing)) return;

    // Caso 2: fallback, nel caso il wrapper venga iniettato più tardi
    var observer = new MutationObserver(function () {
      var el = document.querySelector('.dfd-root[data-dfd-view="Search"]');
      if (linkWrapper(el)) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    setTimeout(function () {
      observer.disconnect();
    }, 10000);
  });
})();

// Aggiunge i controlli nativi al video solo quando riceve il focus via tastiera (tab)
(function () {
  if (window.__videoFocusControlsInit) return;
  window.__videoFocusControlsInit = true;

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.FeatureText__VideoWrapper video').forEach(function (video) {
      video.setAttribute('tabindex', '0');

      video.addEventListener('focus', function () {
        if (video.matches(':focus-visible')) {
          video.controls = true;
        }
      });

      video.addEventListener('blur', function () {
        video.controls = false;
      });
    });
  });
})();

/* Popup Scalapay */
document.addEventListener('click', function (event) {
  var trigger = event.target.closest('.js-scalapay-info');

  if (!trigger) return;

  event.preventDefault();

  var scalapayWidget = document.querySelector('scalapay-widget');

  if (!scalapayWidget) {
    console.warn('Scalapay widget non trovato');
    return;
  }

  var root = scalapayWidget.shadowRoot;

  if (!root) {
    console.warn('Shadow root Scalapay non accessibile');
    return;
  }

  var clickableElements = root.querySelectorAll(
    'button, a, [role="button"]'
  );

  var learnMoreTrigger = Array.prototype.find.call(
    clickableElements,
    function (element) {
      var text = (
        element.textContent ||
        element.getAttribute('aria-label') ||
        ''
      ).trim().toLowerCase();

      return (
        text.indexOf('scopri') !== -1 ||
        text.indexOf('learn') !== -1 ||
        text.indexOf('maggiori') !== -1 ||
        text.indexOf('more') !== -1
      );
    }
  );

  if (!learnMoreTrigger) {
    console.warn('Trigger popup Scalapay non trovato');
    return;
  }

  learnMoreTrigger.click();
});

/* Popup Paypal */
document.addEventListener('click', function (event) {
  var trigger = event.target.closest('.js-paypal-info');

  if (!trigger) return;

  event.preventDefault();

  var paypalMessaging = document.querySelector('.paypal-messaging');

  if (!paypalMessaging) {
    console.warn('PayPal messaging non trovato');
    return;
  }

  var learnMoreTrigger = paypalMessaging.querySelector(
    '.paypal-messaging__info'
  );

  if (!learnMoreTrigger) {
    console.warn('Trigger popup PayPal non trovato');
    return;
  }

  learnMoreTrigger.click();
});

/* Sostituzione arrow PDP */
(function () {
  function replaceRebuyArrowPaths() {
    document
      .querySelectorAll('.rebuy-carousel__arrow')
      .forEach(function (button) {
        const svg = button.querySelector('svg');
        const path = button.querySelector('path');

        if (!svg || !path) return;

        svg.setAttribute('viewBox', '0 0 100 100');

        path.setAttribute(
          'd',
          'M 20,50 L 60,90 L 60,85 L 25,50 L 60,15 L 60,10 Z'
        );

        path.setAttribute('class', 'arrow');

        path.setAttribute(
          'transform',
          'translate(100, 100) rotate(180)'
        );
      });
  }

  replaceRebuyArrowPaths();

  new MutationObserver(replaceRebuyArrowPaths).observe(
    document.body,
    {
      childList: true,
      subtree: true,
    }
  );
})();